import moment from 'moment';
import 'moment/locale/nb';
import { parseISO, format } from 'date-fns';
import { css } from 'styled-components/macro';
import React, {
  useState, useRef, useEffect, useCallback,
} from 'react';
import { withRouter } from 'react-router-dom';
import { animalsActions } from 'src/store/animals/animals.actions';
import { selectAnimals, selectAnimalKeeping, selectCattleForSlaughter } from 'src/store/animals/animals.selectors';
import {
  getBrandingColor,
  colorTypes,
  getBrandingLinks,
  linkTypes,
  getBrandingText,
} from 'src/branding';
import { useSelector, useDispatch } from 'react-redux';
import {
  everyValueInObjectIsFalse,
  getUID,
  nonEmptyArray,
  flatArray,
  int,
  float,
  sumArrayByFunc,
} from 'src/utils/misc.utils';
import Modal from 'src/components/Modal';
import { getProfile } from 'src/store/profile/profile.selectors';
import {
  getPickupWeeks, getStoredState as getStoredStateSelector, getSaveEnrolment, getReturnForms,
} from 'src/store/enrollment/enrollment.selectors';
import { profileActions } from 'src/store/profile/profile.actions';
import {
  weeksInYear,
  momentByWeekAndYear,
  incrementWeek,
} from 'src/utils/date.utils';
import { useToast } from 'src/components/Toast';
import { enrollmentActions } from 'src/store/enrollment/enrollment.actions';
import { getSlaughterRegistrationDeadline, getDefaultBasisYearAndWeekForSelected, getFeaturesEnabled } from 'src/slaughterhouseSpecific';
import LoadingIndicator from 'src/components/LoadingIndicator';
import Helptext from 'src/components/Helptext';
import { Breadcrumbs } from 'src/components/Breadcrumbs';
import { motion } from 'framer-motion';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowDown, faArrowUp } from '@fortawesome/free-solid-svg-icons';
import {
  cattleKindsSell,
  pigKinds,
  sheepKinds,
  maxCharactersCommentWhole,
  maxCharactersCommentAnimal,
  buySellSheepAgeCategoryValues,
  buySellSheepAgeCategoryKinds,
  maxLengthHealthRemarksComment,
  maxCharactersReturnMeatPickupLocation,
  cattleKindsSlaughter,
} from './Config';
import { SpecifyHealthRemarks } from './SpecifyHealthRemarks';
import {
  AddCommentToggleButton,
  EditComment,
  RegisterStep,
  MedicationInfo,
  Checkbox,
  StepWrapper,
  RegisterSlaughterPage,
  MainHeaderWrapper,
  ErrorCont,
  ErrorContHeader,
  EnrolmentInfoLink,
  MedicationWithHoldbackWithinWeekInfo,
  AnimalKindIcon,
  ModalCancelButton,
  StepHeader,
  InfoBox,
  DiseasesList,
  RegNotAvailibleInfo,
  AddNewRowHeader,
  Errors,
  animalKindToNorwegian,
  ignoreYougPartOfCattleKind,
  subcategoryEqualsIgnoreAgePart,
  getErrorsTotAmountAnimalsInHealthRemarksGroup,
  getReturnSheep,
  AfterStepsItems,
  getAllAnimalsSelectedWithHelthRemarksHasHelthRemarks,
  getHasRequiredCommentsForHealthRemarks,
} from './Components';
import { IconBadgeNumber } from '../Dashboard/Dashboard';
import { backendUrl, company } from '../../config';
import {
  padMarkNo, getCurrentWeek, getCurrentYear, getCurrentMoment, expandCollapseVariants,
} from './util';
import {
  AnimalRows, BuyCattle, BuySellSheep, SlaughterBuySelllPigs, SlaughterSellCattle, SLaughterSheep, SpecifyReturnMeatPickupLocation,
} from './EnrolmentParts';
import { InfoBubble } from '../../components/InfoBubble';
import Button from '../../components/Button';
import { routes } from '../routes.manifest';
import {
  Label, Column, Row, LinkLabel, Cell, HTML,
} from '../../components/Layout';
import { getAnimalRowID, getAnimalRowsForGroup, ReturnForm } from './ReturnForm/ReturnForm';
import { WeekPicker } from './WeekPicker';
import { LoadingErrorMessage } from './LoadingErrorMessage';
import { PromptConfirmReset } from './PromptConfirmReset';
import { MainHeader } from './MainHeader';

const liveAnimalTypeValues = ['feeding_animal', 'breeding_animal'];

const RegisterSlaughter = ({ location: { pathname }, history: { push } }) => {
  const dispatch = useDispatch();

  const saveEnrolment = useSelector(getSaveEnrolment);
  const profile = useSelector(getProfile);
  const animalKeeping = useSelector(selectAnimalKeeping);
  const storedStateOnServer = useSelector(getStoredStateSelector);
  const pickupWeeks = useSelector(getPickupWeeks);

  const [animalRowMode, setAnimalRowMode] = useState('add'); // add or edit
  const [indexAnimalRowToEdit, setIndexAnimalRowToEdit] = useState(-1);
  const [selectedAnimalGroup, setSelectedAnimalGroup] = useState(); // pig, cattle ...
  const [selectedAnimalSubGroup, setSelectedAnimalSubGroup] = useState(); // purke, ung okse ...
  const [selectedAction, setSelectedAction] = useState(); // buy, sell ...

  const animals = useSelector(selectedAction === 'slaughter' && selectedAnimalGroup === 'cattle'
    ? selectCattleForSlaughter
    : selectAnimals);

  const [currentAnimalRowInputErrors, setCurrentAnimalRowInputErrors] = useState({});
  const [wanted_pickup_week, setWantedPickupWeek] = useState(getCurrentWeek());
  const [wanted_pickup_year, setWantedPickupBasisYear] = useState(getCurrentYear());

  const [returnSlaughterOptionsGroups, setReturnSlaughterOptionsGroups] = useState([]);
  const [returnSlaughterOptionsCommon, setReturnSlaughterOptionsCommon] = useState({});
  const [returnSlaughterOptionsCommentMeat, setReturnSlaughterOptionsCommentMeat] = useState(null);
  const [returnSlaughterOptionsCommentSkin, setReturnSlaughterOptionsCommentSkin] = useState(null);
  const returnSlaughterOptionsForms = useSelector(getReturnForms);
  const returnSlaughterOptionsForm = returnSlaughterOptionsForms[selectedAnimalGroup] || {};

  const [comment, setComment] = useState(null);
  const [showComment, setShowComment] = useState(false);

  const [animalRowShowCommentForRowNo, setAnimalRowShowCommentForRowNo] = useState(-1);
  const [animalRowShowAddComment, setAnimalRowShowAddComment] = useState(false);
  const [currentAnimalRow, setCurrentAnimalRow] = useState({}); // the row beeing added or edited
  const [currentStep, setCurrentStep] = useState(0);
  const [animalRows, setAnimalRows] = useState([]); // all the rows added  to the enrollment, ready to be submitted
  const [currentAnimalRowErrorMsg, setCurrentAnimalRowErrorMsg] = useState(null);
  const [pickup_on_cattle_agrement, setPickupOnCattleAgreement] = useState(false);
  const [wantMarksSentOnReturn, setWantMarksSentOnReturn] = useState(false);
  const [showReturnAnimalInfo, setShowReturnAnimalInfo] = useState(false);

  const [restrictionsForAnimal, setRestrictionsForAnimal] = useState(false);

  const [agreesAnimalsFitForTransport, setAgreesAnimalsFitForTransport] = useState(false);

  const [agreesExtra, setAgreesExtra] = useState(false);

  const [confirm_group_disease_medication_after_week, setConfirmGroupDiseaseMedicationAfterWeek] = useState(false);
  const [confirm_group_medications_restrain_limit_within_week, setConfirm_group_medications_restrain_limit_within_week] = useState(false);
  const [confirm_choosen_animal_medications_restrain_limit_within_week, setConfirm_choosen_animal_medications_restrain_limit_within_week] = useState(false);
  const [confirm_animals_not_in_crowd, setConfirmAnimalsNotInCrowd] = useState(false);
  const [confirm_animals_not_in_crowd_within_week, setConfirmAnimalsNotInCrowdWithinWeek] = useState(false);
  const [confirm_textual_animal_ids_within_week_ok, setConfirm_textual_animal_ids_within_week_ok] = useState(false);
  const [confirm_textual_animal_ids_medication_ok, setConfirm_textual_animal_ids_medication_ok] = useState(false);

  const [onlyShowSelectedCattleForDropdown, setOnlyShowSelectedCattleForDropdown] = useState(false);

  const [showPromptSwitchToCategoryResetProgress, setShowPromptSwitchToCategoryResetProgress] = useState(null);
  const [showPromptSwitchToActionResetProgress, setShowPromptSwitchToActionResetProgress] = useState(null);

  const [indexAnimalRowToShowDeleteConfirmation, setIndexAnimalRowToShowDeleteConfirmation] = useState(-1);
  const [return_meat_pickup_location, set_return_meat_pickup_location] = useState(null);
  const [hasChoosedRestoreAction, setHasChoosedRestoreAction] = useState(false);

  // the selected cattle from the dropdown, organized by kind
  const [choosedCattleIDsFromDropdowIndexesByKind, setChoosedCattleIDsFromDropdowIndexesByKind] = useState({});

  const [storedLocalstorageState, setStoredLocalstorageState] = useState(null);

  const toast = useToast();

  // choosed cattle are stored by kind like this {kindID: [{cattle1}, {cattle2}], kindID2: [{cattle3}] }
  const getChoosedCattleIdsFromDropdown = (onlyShowSelected) => {
    // we want to show cattles of all kinds when we are showing selected
    // or the filtering is disabled
    if (onlyShowSelected || selectedAnimalSubGroup === 'all_kinds') {
      const r = flatArray(Object.values(choosedCattleIDsFromDropdowIndexesByKind));
      return r || [];
    } else {
      const r = choosedCattleIDsFromDropdowIndexesByKind[ignoreYougPartOfCattleKind(selectedAnimalSubGroup)];
      return r || [];
    }
  };

  const getItemNameSelectedCattleKind = () => {
    const sg = selectedAnimalSubGroup?.toLowerCase();

    if (!sg || sg === 'all_kinds') {
      return 'dyr';
    }
    if (getChoosedCattleIdsFromDropdown().length === 1) {
      return sg;
    }
    return sg.endsWith('e')
      ? `${sg}r`
      : `${sg}er`;
  };

  const setAtributeForCattle = ({ dataKey, value, cattleKey }) => {
    if (animalRowMode === 'add') {
      const currAnimalRowCopy = {
        ...currentAnimalRow,
      };
      currAnimalRowCopy.cattle[cattleKey] = {
        ...currentAnimalRow.cattle[cattleKey],
        [dataKey]: value,
      };

      setCurrentAnimalRow(currAnimalRowCopy);
    } else {
      setCurrentAnimalRow((old) => ({ ...old, [dataKey]: value }));
    }
  };

  const setAtributeForIndividualPig = ({ key, value, idxPig }) => {
    if (animalRowMode === 'add') {
      const individualPigs = [...currentAnimalRow.individual_pigs];
      individualPigs[idxPig][key] = value;

      setCurrentAnimalRow({
        ...currentAnimalRow,
        individual_pigs: individualPigs,
      });
    } else {
      setCurrentAnimalRow({
        ...currentAnimalRow,
        [key]: value,
      });
    }
  };

  // ==
  // == Listeners for when the users type inside some input-fields related to return-animals
  // ==
  const ontypingInvividualPigsAmount = useRef();

  // when changing the amount of pigs in individual mode or sheep, add or hide
  // so the input-sections for return for each animal according to the amount
  const onTypingAmountForAnimalsWithReturn = (key, amount, updateAnimalRowAmount) => {
    const existingData = currentAnimalRow[key] || [];
    const newDataArrayLength = Math.max(existingData.length || 0, parseInt(amount, 10) || 0);
    const newData = [...Array(newDataArrayLength).fill({})];

    // transfer existing return-animals so that they do not get overwritten
    // return-animnals that where stored but are now not shown, because the amount decreases,
    // are still stored, but with a flag
    for (let i = 0; i < newData.length; i++) {
      const elemNoLongerShown = i + 1 > amount;
      if (elemNoLongerShown) {
        newData[i] = { ...existingData[i], disabled: true };
      } else {
        newData[i] = existingData[i] || {};
        newData[i].disabled = false;
      }
    }
    // reset old input errors
    setCurrentAnimalRowInputErrors({});

    setCurrentAnimalRow((old) => {
      const newRow = {
        ...old,
        [key]: newData,
      };

      if (updateAnimalRowAmount) {
        newRow.amount = parseInt(amount, 10);
      }

      return newRow;
    });
  };

  ontypingInvividualPigsAmount.current = (amount) => {
    onTypingAmountForAnimalsWithReturn('individual_pigs', amount, true);
  };

  const onTypingSlaughterSheepReturnAmount = useRef();

  onTypingSlaughterSheepReturnAmount.current = (amount) => {
    onTypingAmountForAnimalsWithReturn('return_sheep', amount, false);
  };

  const getHasMedicationsWithRestrainWithinWeek = () => {
    if (!saveEnrolment.response) {
      return false;
    }
    const response = saveEnrolment.response;

    if (nonEmptyArray(response.animal_remarks) && response.animal_remarks.some((a) => nonEmptyArray(a.medications_restrain_limit_within_week))) {
      return true;
    }

    if (nonEmptyArray(response.animals_maybe_in_group_remarks) && response.animals_maybe_in_group_remarks.some((a) => nonEmptyArray(a.medications_restrain_limit_within_week))) {
      return true;
    }

    if (nonEmptyArray(response.animals_with_textual_animal_ids) && response.animals_with_textual_animal_ids.some((a) => a.medications_restrain_limit_within_week)) {
      return true;
    }

    if (response.group_remarks && response.group_remarks.group_medications_restrain_limit_within_week) {
      return true;
    }

    return false;
  };

  const onChoosedCattleIDSsFromDropdown = (ids) => {
    // look up the kind for each id and add it to the correct kind

    const hasChoosedFromAllKinds = onlyShowSelectedCattleForDropdown || selectedAnimalSubGroup === 'all_kinds';
    if (!ids?.length) {
      if (hasChoosedFromAllKinds) {
        setChoosedCattleIDsFromDropdowIndexesByKind({});
      } else {
        setChoosedCattleIDsFromDropdowIndexesByKind({
          ...choosedCattleIDsFromDropdowIndexesByKind,
          [ignoreYougPartOfCattleKind(selectedAnimalSubGroup)]: [],
        });
      }
      return;
    }

    const cattles = animals?.animals?.cattle || [];
    const kindsForCattleById = {};

    cattles.forEach((c) => {
      kindsForCattleById[getKeyForCattle(c)] = ignoreYougPartOfCattleKind(c.subcategory_name);
    });

    let choosedByKind = null;
    // we know that ids will contain all choosed so we reset the selected
    if (hasChoosedFromAllKinds) {
      choosedByKind = {};
    } else { // ids only contain choosed from one kind, so we only reset selected of that kind
      choosedByKind = { ...choosedCattleIDsFromDropdowIndexesByKind };
      const kindChoosed = ignoreYougPartOfCattleKind(kindsForCattleById[ids[0]]);
      choosedByKind[kindChoosed] = [];
    }

    if (!choosedByKind) {
      choosedByKind = {};
    }

    ids.forEach((id) => {
      const kindForId = kindsForCattleById[id];

      if (!choosedByKind[kindForId]) {
        choosedByKind[kindForId] = [];
      }
      choosedByKind[kindForId].push(id);
    });

    setChoosedCattleIDsFromDropdowIndexesByKind(choosedByKind);
  };

  const refElemStartOfRegularEnrolmentFlow = useRef();
  const refElemStartOfCustomEnrolmentFlow = useRef();

  const [scrolledTo] = useState({});

  const scrollToElement = useCallback((current, toTop) => {
    requestAnimationFrame(() => {
      if (!document.documentElement || !document.scrollingElement || !current) {
        return;
      }

      const scrollTop = Math.max(
        window.pageYOffset,
        document.documentElement.scrollTop,
        document.scrollingElement.scrollTop,
        document.body.scrollTop,
        window.scrollY,
      );

      const { top, bottom, height } = current.getBoundingClientRect();

      if (
        top < window.innerHeight * 0.1
        || bottom > window.innerHeight * 0.9
      ) {
        const isIOS = /iPad|iPhone|iPod/.test(navigator.platform) || (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);
        const scrollElem = isIOS ? window : document.body;
        scrollElem.scrollTo({
          top: scrollTop + top - (height > window.innerHeight
            ? 0
            : !toTop
              ? (window.innerHeight - height) / 2
              : 210),
          behavior: 'smooth',
        });
      }
    });
  }, []);

  const scrollToMe = useCallback((name, current) => {
    if (!current || scrolledTo[name]) {
      return;
    }
    scrollToElement(current);
    scrolledTo[name] = current;
  }, [scrolledTo, scrollToElement]);

  const onClickStep = (step) => {
    setCurrentStep((prev) => Math.max(prev, step));
  };

  const getUIDForNewAnimalRow = (rows) => {
    let uid = '';

    const containsUID = (u) => (rows || animalRows)?.some((a) => a.uid === u);

    do {
      uid = getUID();
    } while (containsUID(uid));

    return uid;
  };

  const addAnimalRow = (row) => {
    setAnimalRows((prev) => [
      ...prev || [],
      { ...row, hidden: false, uid: getUIDForNewAnimalRow(prev) },
    ]);
  };

  const getKeyForCattle = (cattle) => `${cattle.mark_no};${cattle.individual_no};${cattle.subcategory_name}`;

  const isPigsWithIndividualRegistration = () => {
    if (!selectedAnimalSubGroup) {
      return false;
    }

    const correctSubgroup = selectedAnimalSubGroup?.toLowerCase() === 'purke' || selectedAnimalSubGroup?.toLowerCase() === 'råne';

    return correctSubgroup && getFeaturesEnabled().purke_raane_individual_registration;
  };

  const selectFirstValidAnimalSubGroup = () => {
    if (selectedAnimalGroup === 'cattle') {
      currentAnimalRow.cattle = {};

      if (selectedAction === 'buy') {
        setCurrentStep(4);
        setCurrentAnimalRow((old) => ({ ...old, live_animal_type: liveAnimalTypeValues[0] }));
      }
      setSelectedAnimalSubGroup((selectedAction === 'slaughter' ? cattleKindsSlaughter : cattleKindsSell)
        .map((e) => e.toLowerCase())
        .filter((k) => userHasAnimalKinds.indexOf(k.toLowerCase()) >= 0)[0]);
    } else if (selectedAnimalGroup === 'pigs') {
      setSelectedAnimalSubGroup(pigKinds[0]);
    } else if (selectedAnimalGroup === 'sheep') {
      if (selectedAction === 'slaughter') {
        setSelectedAnimalSubGroup(sheepKinds[0]);
      } else if (selectedAction === 'buy' || selectedAction === 'sell') {
        setCurrentAnimalRow((old) => ({ ...old, sheep_kind: buySellSheepAgeCategoryValues[0] }));
      }
    }

    if (isRegularAnimalFlow()) {
      scrollToElement(refElemStartOfRegularEnrolmentFlow.current, true);
    } else {
      scrollToElement(refElemStartOfCustomEnrolmentFlow.current, true);
    }
  };

  const addAnimalRows = (rowsToAdd) => {
    setAnimalRows((prev) => {
      const next = [...prev];

      for (const row of rowsToAdd) {
        next.push({ ...row, hidden: false, uid: getUIDForNewAnimalRow(next) });
      }

      return next;
    });
  };

  const removeNonUsedRturnFormGroups = (animalRows) => {
    setReturnSlaughterOptionsGroups((old) => old.filter((group) => getAnimalRowsForGroup(group, getAnimalRowsWithReturn('return_meat', animalRows, false)).length > 0));
  };

  const updateAnimalRow = (row, index) => {
    const rowsCopy = [...animalRows];
    rowsCopy[index] = { ...row };

    if (getFeaturesEnabled().return_form) {
      // delete return options groups if the id of the animakl changed or the animal no longer has return meat
      const animal = rowsCopy[index];
      if (animal.return_sheep) {
        if (Array.isArray(animal.return_sheep)) {
          for (const [rsIdx, rs] of animal.return_sheep.entries()) {
            if (rs.disabled) {
              continue;
            }
            // we may have added a new sheep, if this is the case, we cannot compare
            const existingReturnSheep = animalRows[index].return_sheep[rsIdx];
            if (existingReturnSheep) {
              const rowIdChanged = getAnimalRowID(rs) !== getAnimalRowID(existingReturnSheep);
              // new identify means we need to readd to return group
              if (rowIdChanged || !rs.return_meat) {
                delete rs.return_options_groups;
              }
            }
          }
        }
      } else {
        const rowIdChanged = getAnimalRowID(animal, { ignoreIdxInClub: true }) !== getAnimalRowID(animalRows[index], { ignoreIdxInClub: true });
        if (rowIdChanged || (selectedAnimalGroup !== 'sheep' && !animal.return_meat)) {
          delete animal.return_options_groups;
        }
      }
    }

    setAnimalRows((old) => rowsCopy);

    if (getFeaturesEnabled().return_form) {
      // when we edited the animal, we may also have deleted some of the return options groups
      // so we check that any groups that does not exist in any animal rows now, are deleted
      removeNonUsedRturnFormGroups(rowsCopy);
    }
  };

  const updateCattleInRow = (updatedCattle, cattleKey) => {
    const currAnimalRowCopy = {
      ...currentAnimalRow,
    };
    currAnimalRowCopy.cattle[cattleKey] = updatedCattle;
    setCurrentAnimalRow(currAnimalRowCopy);
  };

  const deleteAnimalRow = (index) => setAnimalRows((rows) => (rows || []).filter((_, i) => i !== index));

  // get data needed before registration
  useEffect(() => {
    dispatch(profileActions.fetch());
    dispatch(animalsActions.fetch());
    dispatch(animalsActions.fetchAnimalKeeping({ slaughterPage: true }));
    dispatch(enrollmentActions.fetchPickupWeeks());
    dispatch(enrollmentActions.fetchStoredState());
  }, [dispatch]);

  const getAnimalRowsWithReturn = (kind, animalRows) => {
    const rows = [];

    for (const row of animalRows) {
      if ((selectedAnimalGroup === 'pigs' || selectedAnimalGroup === 'cattle') && !row.disabled && row[kind]) {
        if (selectedAnimalGroup === 'pigs' && row.subcategory_name !== 'Purke' && row.subcategory_name !== 'Råne') {
          Array.from(Array(+row.return_meat)).map((_, idx) => rows.push({
            ...row,
            amount: 1,
            return_meat: 1,
            idx_in_club: idx,
            return_options_groups: row.return_options_groups?.[idx] ? [row.return_options_groups?.[idx]] : [],
          }));
        } else {
          rows.push(row);
        }
      }
      if (
        selectedAnimalGroup === 'sheep'
        && row.return_sheep
        && !row.disabled
        && row.return_sheep.some((s) => s[kind])
      ) {
        row.return_sheep.forEach((rs) => {
          if (!rs.disabled && rs[kind]) {
            rows.push({
              ...rs,
              subcategory_name: row.subcategory_name,
              animal_row_id: getAnimalRowID({ ...rs, subcategory_name: row.subcategory_name }),
            });
          }
        });
      }
    }
    return rows;
  };

  const enrolmentHasAnimalsWithReturnMeat = getAnimalRowsWithReturn('return_meat', animalRows).length > 0;
  const enrolmentHasAnimalsWithReturnSkin = getAnimalRowsWithReturn('return_skin', animalRows).length > 0;

  // fetch forms with options for return animals
  useEffect(() => {
    if (
      selectedAnimalGroup
      && (enrolmentHasAnimalsWithReturnMeat || enrolmentHasAnimalsWithReturnSkin)
      && returnSlaughterOptionsForm
      && !returnSlaughterOptionsForm.data
      && !returnSlaughterOptionsForm.isFetching && !returnSlaughterOptionsForm.error
    ) {
      dispatch(enrollmentActions.fetchReturnForms({ animalKind: selectedAnimalGroup }));
    }
  }, [enrolmentHasAnimalsWithReturnMeat, enrolmentHasAnimalsWithReturnSkin, selectedAnimalGroup, returnSlaughterOptionsForm, returnSlaughterOptionsForm.data, returnSlaughterOptionsForm.isFetching, returnSlaughterOptionsForm.error, dispatch]);

  // load saved data from temp storage once we have profile data to determince which user to load
  useEffect(() => {
    moment.locale('no');
    if (!(profile && profile.profile && profile.profile.supplier_no)) {
      return;
    }

    if (localStorage.getItem('sw-enrollment') === null) {
      return;
    }

    // get saved state for correct user
    const parsed = JSON.parse(localStorage.getItem('sw-enrollment'));

    if (!parsed || (profile && profile.profile && parsed.supplier_no !== profile.profile.supplier_no)) {
      return;
    }
    if (!storedLocalstorageState) {
      setStoredLocalstorageState(parsed);
    }
  }, [profile, profile.isFeteching, profile.profile, storedLocalstorageState]);

  const getCattleForSearchableDropdownBasedOnFilters = () => {
    const showOfAllKinds = onlyShowSelectedCattleForDropdown;

    if (showOfAllKinds) {
      return getCattlesForSearchableDropdown(false);
    }

    return getCattlesForSearchableDropdown(true);
  };

  const getCattlesForSearchableDropdown = (useFilters) => {
    let cattle = animals?.animals?.cattle || [];

    if (useFilters && selectedAnimalSubGroup !== 'all_kinds') {
      cattle = cattle.filter((a) => subcategoryEqualsIgnoreAgePart(a.subcategory_name, selectedAnimalSubGroup));
    }

    return cattle.map((e) => ({
      mark_no: e.mark_no,
      individual_no: e.individual_no,
      display: `${padMarkNo(e.mark_no)} / ${e.individual_no} f:${format(parseISO(e.birthdate), 'dd.MM.yy')}`,
      birthdate: `${format(parseISO(e.birthdate), 'dd.MM.yy')}`,
      uid: getKeyForCattle(e),
      subcategory_name: e.subcategory_name,
    }));
  };

  // if we edit an animal/group and the edit will result in a different animal
  // delete the health remark data for that animal/group so the user has to specify it again
  const removeHealthRemarksIfAnimalChanged = (animal) => {
    const a = { ...animal };
    if (animalRowMode === 'add') {
      return a;
    }
    if (selectedAnimalGroup === 'cattle') {
      if (getKeyForCattle(a) !== getKeyForCattle(animalRows[indexAnimalRowToEdit])) {
        delete a.health_remarks_code;
        delete a.health_remarks_cnt;
        delete a.health_remarks_comment;
      }
    } else if (selectedAnimalGroup === 'pigs') {
      if (isPigsWithIndividualRegistration()) {
        if (a.ear_tag !== animalRows[indexAnimalRowToEdit].ear_tag || a.subcategory_name !== animalRows[indexAnimalRowToEdit].subcategory_name) {
          delete a.health_remarks_code;
          delete a.health_remarks_comment;
          delete a.health_remarks_groups; // if we changed from groupp pigs to individual pigs, also reset the helath remark grouos
        }
      } else {
        if (`${a.club_no}${a.subcategory_name}` !== `${animalRows[indexAnimalRowToEdit].club_no}${animalRows[indexAnimalRowToEdit].subcategory_name}`) {
          delete a.health_remarks_comment;

          delete a.health_remarks_groups; // if we changed from individual to group, also reset these which is for individual pigs
          delete a.health_remarks_code;
        }
      }
    } else if (selectedAnimalGroup === 'sheep') {
      if (a.subcategory_name !== animalRows[indexAnimalRowToEdit].subcategory_name) {
        delete a.health_remarks_groups;
      }
      if (Array.isArray(getReturnSheep(a))) {
        const returnSheep = getReturnSheep(a).map((rs, rsIdx) => {
          const sheep = { ...rs };

          if (
            (a.subcategory_name !== animalRows[indexAnimalRowToEdit].subcategory_name)
            || (getReturnSheep(animalRows[indexAnimalRowToEdit])[rsIdx] && sheep.individual_no !== getReturnSheep(animalRows[indexAnimalRowToEdit])[rsIdx].individual_no)
          ) {
            delete sheep.health_remarks_code;
            delete sheep.health_remarks_comment;
          }
          return sheep;
        });
        a.return_sheep = [...returnSheep];
      }
    }

    return a;
  };

  const isRegularAnimalFlow = () => selectedAction === 'slaughter'
    || selectedAnimalGroup === 'cattle'
    || selectedAnimalGroup === 'pigs';

  const showRegularAddAnimalFlow = () => {
    if (!selectedAnimalGroup || restrictionsForAnimal || currentStep < 1 || !isRegularAnimalFlow()) {
      return false;
    }
    if (selectedAnimalGroup === 'pigs') return !(hasInvalidHelsegrisStatus && helsegrisCheckEnabled);

    return true;
  };

  const onStoreStateOnServer = () => {
    dispatch(
      enrollmentActions.saveStoredState({
        onSuccess: () => {
          toast.addMessage('Utkast lagret');
        },
        onError: () => {
          toast.addError('Kunne ikke lagre utkast');
        },
        tempStorageState: {
          state: getStoredState(),
          user: profile.profile.supplier_no,
          lastUpdated: moment().format('DD-MM-YYYY  HH:mm:ss'),
        },
      }),
    );
  };

  const restoreState = (old) => {
    for (const propName of Object.getOwnPropertyNames(propsToStore)) {
      if (old.hasOwnProperty(propName)) {
        propsToStore[propName].set(old[propName]);
      }
    }
  };

  const propsToStore = {
    indexAnimalRowToEdit: {
      get: indexAnimalRowToEdit,
      set: setIndexAnimalRowToEdit,
    },
    selectedAnimalGroup: {
      get: selectedAnimalGroup,
      set: setSelectedAnimalGroup,
    },
    selectedAnimalSubGroup: {
      get: selectedAnimalSubGroup,
      set: setSelectedAnimalSubGroup,
    },
    selectedAction: { get: selectedAction, set: setSelectedAction },

    currentAnimalRowInputErrors: {
      get: currentAnimalRowInputErrors,
      set: setCurrentAnimalRowInputErrors,
    },
    wantedPickupBasisWeek: {
      get: wanted_pickup_week,
      set: setWantedPickupWeek,
    },
    wantedPickupBasisYear: {
      get: wanted_pickup_year,
      set: setWantedPickupBasisYear,
    },
    returnSlaughterOptionsGroups: {
      get: returnSlaughterOptionsGroups,
      set: setReturnSlaughterOptionsGroups,
    },
    returnSlaughterOptionsCommon: {
      get: returnSlaughterOptionsCommon,
      set: setReturnSlaughterOptionsCommon,
    },
    returnSlaughterOptionsCommentMeat: {
      get: returnSlaughterOptionsCommentMeat,
      set: setReturnSlaughterOptionsCommentMeat,
    },
    returnSlaughterOptionsCommentSkin: {
      get: returnSlaughterOptionsCommentSkin,
      set: setReturnSlaughterOptionsCommentSkin,
    },
    animalRowShowCommentForRowNo: {
      get: animalRowShowCommentForRowNo,
      set: setAnimalRowShowCommentForRowNo,
    },
    animalRowShowAddComment: {
      get: animalRowShowAddComment,
      set: setAnimalRowShowAddComment,
    },
    currentAnimalRow: { get: currentAnimalRow, set: setCurrentAnimalRow },
    currentStep: { get: currentStep, set: setCurrentStep },
    animalRows: { get: animalRows, set: setAnimalRows },
    currentAnimalRowErrorMsg: {
      get: currentAnimalRowErrorMsg,
      set: setCurrentAnimalRowErrorMsg,
    },
    pickupOnCattleAgreement: {
      get: pickup_on_cattle_agrement,
      set: setPickupOnCattleAgreement,
    },
    wantMarksSentOnReturn: {
      get: wantMarksSentOnReturn,
      set: setWantMarksSentOnReturn,
    },
    agreesAnimalsFitForTransport: {
      get: agreesAnimalsFitForTransport,
      set: setAgreesAnimalsFitForTransport,
    },
    agreesExtra: {
      get: agreesExtra,
      set: setAgreesExtra,
    },
    animalRowMode: {
      get: animalRowMode,
      set: setAnimalRowMode,
    },
    comment: {
      get: comment,
      set: setComment,
    },
    showComment: {
      get: showComment,
      set: setShowComment,
    },
    choosedCattleIDsFromDropdowIndexesByKind: {
      get: choosedCattleIDsFromDropdowIndexesByKind,
      set: setChoosedCattleIDsFromDropdowIndexesByKind,
    },
    return_meat_pickup_location: {
      get: return_meat_pickup_location,
      set: set_return_meat_pickup_location,
    },
  };

  // store state in localstorage
  useEffect(() => {
    if (!profile || !profile.profile || !profile.profile.supplier_no) {
      return;
    }
    const toStore = {};

    for (const propName of Object.getOwnPropertyNames(propsToStore)) {
      toStore[propName] = propsToStore[propName].get;
    }

    localStorage.setItem(
      'sw-enrollment',
      JSON.stringify(
        {
          lastUpdated: moment().format('DD-MM-YYYY  HH:mm:ss'),
          state: toStore,
          supplier_no: profile.profile.supplier_no,
        },
        null,
      ),
    );
  }, [...Object.values(propsToStore).map((p) => p.get)]);

  const getStoredState = () => {
    const stored = {};

    for (const propName of Object.getOwnPropertyNames(propsToStore)) {
      stored[propName] = propsToStore[propName].get;
    }

    return stored;
  };

  const getCurrentAnimalRowIsValid = () => {
    if (currentAnimalRow.amount === 0) {
      return false;
    }

    if (((selectedAnimalGroup === 'sheep' && ['slaughter', 'buy'].indexOf(selectedAction) >= 0)
      || (selectedAnimalGroup === 'cattle' && ['buy'].indexOf(selectedAction) >= 0)
      || (selectedAnimalGroup === 'pigs' && ['buy', 'slaughter', 'sell'].indexOf(selectedAction) >= 0))
      && !currentAnimalRow.amount) {
      return false;
    }

    // check comment lengths
    if (currentAnimalRow.comment && currentAnimalRow.comment.length > maxCharactersCommentAnimal) {
      return false;
    }

    if (
      selectedAnimalGroup === 'cattle'
      && animalRowMode === 'add' && currentAnimalRow.cattle
      && Object.values(currentAnimalRow.cattle).some((c) => c.comment && c.comment.length > maxCharactersCommentAnimal)
    ) {
      return false;
    }

    if (selectedAnimalGroup === 'pigs') {
      if (selectedAnimalSubGroup && isPigsWithIndividualRegistration()) {
        if (animalRowMode === 'add') {
          for (const individualPig of currentAnimalRow.individual_pigs) {
            if (!individualPig.disabled && !individualPig.ear_tag) {
              return false;
            }
          }
        } else if (animalRowMode === 'edit') {
          if (!currentAnimalRow.ear_tag) {
            return false;
          }
        }

        return true;
      }
      if (selectedAction === 'slaughter') {
        return currentAnimalRow.club_no;
      }
    } else if (selectedAnimalGroup === 'sheep') {
      if (selectedAction === 'slaughter') {
        return (!(Array.isArray(currentAnimalRow.return_skin) && currentAnimalRow.return_skin.some((rs) => rs.individual_no === '')));
      }
      if (selectedAction === 'sell') {
        return currentAnimalRow.sheep_individual_no;
      }
    } else if (selectedAnimalGroup === 'cattle' && ['slaughter', 'sell'].indexOf(selectedAction) >= 0) {
      if (animalRowMode === 'add') {
        return (
          currentAnimalRow.cattle
                    && Object.getOwnPropertyNames(currentAnimalRow.cattle).length > 0
        );
      } else {
        return currentAnimalRow.mark_no && currentAnimalRow.individual_no;
      }
    }

    return true;
  };

  // we check that some data that is not validated on-the-fly is valid and specified
  // if required
  const getRegistrationReadyForSending = () => {
    /*
      ============================
      Validation for buy/sell/slaughter
      ============================
    */
    if (currentAnimalRowErrorMsg) {
      return false;
    }

    if (comment && comment.length > maxCharactersCommentWhole) {
      return false;
    }

    if (getFeaturesEnabled().return_form
      && (enrolmentHasAnimalsWithReturnMeat)
      && getAnimalRowsWithReturn('return_meat', animalRows).filter((a) => {
        if (!a.return_options_groups || !Array.isArray(a.return_options_groups)) {
          return true;
        }

        if (selectedAnimalGroup === 'sheep' || selectedAnimalGroup === 'cattle') {
          return a.return_options_groups.length === 0;
        } else if (selectedAnimalGroup === 'pigs') {
          return sumArrayByFunc(a.return_options_groups, (e) => int(e.amount_animals)) < int(a.return_meat);
        } else {
        }
      }).length > 0) {
      return false;
    }

    if (shouldShowReturnMeatPickupLocationEdit && (!return_meat_pickup_location || return_meat_pickup_location.length > maxCharactersReturnMeatPickupLocation)) {
      return false;
    }

    if (selectedAction === 'sell' || selectedAction === 'buy') {
      const weeksValid = selectedAnimalGroup !== 'pigs' || getIsWantedPickupBasisWeekValid([
        wanted_pickup_year,
        wanted_pickup_week,
      ]);
      const confirmationTransportValid = selectedAction !== 'sell' || agreesAnimalsFitForTransport;
      return (weeksValid
        && confirmationTransportValid
        && animalRows
        && animalRows.length > 0
      );
    }

    if (selectedAction !== 'slaughter') {
      return true;
    }

    /*
       ============================
        Validation for slaughter only
       ============================
      */

    if (animalRows.find((a) => getErrorsTotAmountAnimalsInHealthRemarksGroup(a))) {
      return false;
    }
    if (!getHasRequiredCommentsForHealthRemarks(animalRows, selectedAnimalGroup)) {
      return false;
    }

    let hasHealthRemarksNotYetSpecified = false;
    if (getAnimalRowsHasOneOrMoreHealthRemarks() && getAllAnimalsSelectedWithHelthRemarksHasHelthRemarks(animalRows, selectedAnimalGroup)) {
      hasHealthRemarksNotYetSpecified = true;
    } else {
      hasHealthRemarksNotYetSpecified = false;
    }

    const healthRemarksCommentsAboveLengthLimit = animalRows.some((a) => (a.health_remarks_comment && a.health_remarks_comment.length > maxLengthHealthRemarksComment)
      || a.health_remarks_groups && (a.health_remarks_groups.some((g) => g.health_remarks_comment && g.health_remarks_comment.length > maxLengthHealthRemarksComment)))
      || animalRows.some((ar) => getReturnSheep(ar).find((rs) => rs.health_remarks_comment && rs.health_remarks_comment.length > maxLengthHealthRemarksComment));

    const hasGroupMedication = saveEnrolment.response
            && saveEnrolment.response.group_remarks
            && nonEmptyArray(
              saveEnrolment.response.group_remarks
                .group_medications_restrain_limit_after_week,
            );

    const hasGroupMedicationWithinWeek = saveEnrolment.response
      && saveEnrolment.response.group_remarks
      && nonEmptyArray(saveEnrolment.response.group_remarks.group_medications_restrain_limit_within_week);

    const hasIndividualsMaybeInGroupMedicationAfterWeek = saveEnrolment.response
      && saveEnrolment.response.animals_maybe_in_group_remarks
      && saveEnrolment.response.animals_maybe_in_group_remarks.some((a) => nonEmptyArray(a.medications_restrain_limit_after_week));

    const hasIndividualsMaybeInGroupMedicationWithinWeek = saveEnrolment.response
      && saveEnrolment.response.animals_maybe_in_group_remarks
      && saveEnrolment.response.animals_maybe_in_group_remarks.some((a) => nonEmptyArray(a.medications_restrain_limit_within_week));

    const hasTextualAnimalIdsMedicationWithinWeek = saveEnrolment.response
      && saveEnrolment.response.animals_with_textual_animal_ids
      && saveEnrolment.response.animals_with_textual_animal_ids.some((a) => nonEmptyArray(a.medications_restrain_limit_within_week));

    const hasTextualAnimalIdsMedicationAfterWeek = saveEnrolment.response
      && saveEnrolment.response.animals_with_textual_animal_ids
      && saveEnrolment.response.animals_with_textual_animal_ids.some((a) => nonEmptyArray(a.medications_restrain_limit_after_week));

    const hasChoosenAnimalsMedicationWithinWeek = saveEnrolment.response
      && saveEnrolment.response.animal_remarks
      && saveEnrolment.response.animal_remarks.some((a) => nonEmptyArray(a.medications_restrain_limit_within_week));

    return (wanted_pickup_week && (!comment || comment.length <= maxCharactersCommentWhole)
      && !healthRemarksCommentsAboveLengthLimit
      && !hasHealthRemarksNotYetSpecified
      && (!hasGroupMedication || (hasGroupMedication && confirm_group_disease_medication_after_week))
      && (!hasGroupMedicationWithinWeek || (hasGroupMedicationWithinWeek && confirm_group_medications_restrain_limit_within_week))
      && (!hasIndividualsMaybeInGroupMedicationAfterWeek || (hasIndividualsMaybeInGroupMedicationAfterWeek && confirm_animals_not_in_crowd))
      && (!hasIndividualsMaybeInGroupMedicationWithinWeek || (hasIndividualsMaybeInGroupMedicationWithinWeek && confirm_animals_not_in_crowd_within_week))
      && (!hasTextualAnimalIdsMedicationAfterWeek || (hasTextualAnimalIdsMedicationAfterWeek && confirm_textual_animal_ids_medication_ok))
      && (!hasTextualAnimalIdsMedicationWithinWeek || (hasTextualAnimalIdsMedicationWithinWeek && confirm_textual_animal_ids_within_week_ok))
      && (!hasChoosenAnimalsMedicationWithinWeek || (hasChoosenAnimalsMedicationWithinWeek && confirm_choosen_animal_medications_restrain_limit_within_week))
      && getIsWantedPickupBasisWeekValid([wanted_pickup_year, wanted_pickup_week])
      && agreesAnimalsFitForTransport
      && ((getFeaturesEnabled().extraCheckboxConfirmRegisterSlaughter && agreesExtra) || (!getFeaturesEnabled().extraCheckboxConfirmRegisterSlaughter))
      && animalRows
      && animalRows.length > 0
    );
  };

  const getIsSendingEnrolment = () => saveEnrolment.isFetching;

  const validateAddEditAnimalRow = () => {
    if (!currentAnimalRow) {
      return true;
    }

    if (selectedAction === 'slaughter' && parseInt(currentAnimalRow.health_remarks_cnt, 10) > currentAnimalRow.amount) {
      return 'Antall dyr med helseavvik kan ikke være større enn antallet dyr.';
    }

    if (!isPigsWithIndividualRegistration() && selectedAnimalGroup !== 'cattle' && currentAnimalRow.has_health_remarks && !currentAnimalRow.health_remarks_cnt) {
      return 'Antall dyr med helseavvik er påkrevd.';
    }

    if (
      selectedAction === 'slaughter' && currentAnimalRow.health_remarks_cnt
      && (Number.isNaN(int(currentAnimalRow.health_remarks_cnt))
        || int(currentAnimalRow.health_remarks_cnt) <= 0
        || float(currentAnimalRow.health_remarks_cnt, 10) % 1 !== 0)
    ) {
      return 'Ugyldig antall dyr med helseavvik.';
    }

    return undefined;
  };

  const addEditPigRow = () => {
    /*
      ============================
      GRIS
      ============================
    */
    const inputErrors = { ...currentAnimalRowInputErrors };

    if (!isPigsWithIndividualRegistration()) {
      inputErrors.amount = !/^[1-9][0-9]*$/.test(currentAnimalRow.amount.toString());
    }
    if (selectedAction === 'slaughter' && !isPigsWithIndividualRegistration()) {
      inputErrors.club_no = !/^[0-9]{4}$/.test(currentAnimalRow.club_no.toString());
    }

    // if individual pigs, check for invalid ear tag
    if (selectedAction === 'slaughter' && isPigsWithIndividualRegistration()) {
      delete inputErrors.individual_pigs;
      if (animalRowMode === 'add') {
        for (const [i, individualPig] of currentAnimalRow.individual_pigs.entries()) {
          delete individualPig.club_no;

          if (!individualPig.disabled) {
            const has_error = !/^[0-9]{1,5}$/.test(individualPig.ear_tag) || individualPig.ear_tag === '00000';
            if (has_error) {
              if (!Array.isArray(inputErrors.individual_pigs)) {
                inputErrors.individual_pigs = [];
              }
              inputErrors.individual_pigs[i] = { ear_tag: true };
            }
          }
        }
      } else if (animalRowMode === 'edit') {
        inputErrors.ear_tag = !/^[0-9]{1,5}$/.test(currentAnimalRow.ear_tag) || currentAnimalRow.ear_tag === '00000';
      }
    }

    setCurrentAnimalRowInputErrors(inputErrors);

    if (!everyValueInObjectIsFalse(inputErrors)) {
      return true;
    }

    if (
      selectedAction === 'slaughter' && !isPigsWithIndividualRegistration()
      && animalRows.filter((_, i) => (animalRowMode === 'edit' ? i !== indexAnimalRowToEdit : true))
        .some((e) => e.club_no === currentAnimalRow.club_no && e.subcategory_name === selectedAnimalSubGroup)
    ) {
      return 'Griser med valgt klubbenummer er allerede lagt til.';
    }

    if (selectedAction === 'slaughter' && isPigsWithIndividualRegistration() && animalRowMode === 'add') {
      const ear_tags = [];

      for (const individualPig of currentAnimalRow.individual_pigs.filter((r) => !r.disabled)) {
        if (ear_tags.indexOf(individualPig.ear_tag) >= 0) {
          return `Det finnes flere ${selectedAnimalSubGroup?.toLowerCase() === 'purke' ? 'purker' : 'råner'} med samme øremerke.`;
        }
        ear_tags.push(individualPig.ear_tag);
      }
    }

    if (selectedAction === 'slaughter' && isPigsWithIndividualRegistration() && animalRowMode === 'edit'
      && animalRows.filter((_, i) => i !== indexAnimalRowToEdit).some((e) => e.ear_tag === currentAnimalRow.ear_tag)
    ) {
      return 'Griser med valgt øremerke er allerede lagt til.';
    }

    if (selectedAction === 'slaughter' && isPigsWithIndividualRegistration() && animalRowMode === 'add') {
      for (const individualPig of currentAnimalRow.individual_pigs.filter(
        (pr) => !pr.disabled,
      )) {
        if (animalRows.some((ar) => ar.ear_tag === individualPig.ear_tag)) {
          return 'Griser med valgt øremerke er allerede lagt til.';
        }
      }
    }

    if (
      (selectedAction === 'sell' || selectedAction === 'buy') && animalRows
        .filter((_, i) => (animalRowMode === 'edit' ? i !== indexAnimalRowToEdit : true))
        .some((e) => e.subcategory_name === selectedAnimalSubGroup)
    ) {
      return 'Griser av valgt type er allerede lagt til.';
    }

    if (
      selectedAction === 'slaughter' && int(currentAnimalRow.return_meat) > int(currentAnimalRow.amount)
    ) {
      return 'Antall dyr med returkjøtt kan ikke være større enn antallet dyr.';
    }

    let deleteReturnOptionsGroups = false;

    if (getFeaturesEnabled().return_form && Array.isArray(currentAnimalRow.return_options_groups) && int(currentAnimalRow.return_meat) < sumArrayByFunc(currentAnimalRow.return_options_groups, (g) => int(g.amount_animals))) {
      deleteReturnOptionsGroups = window.confirm(
        'Antall returkjøtt er mindre enn antallet dyr fordelt i oppdelinger for returkjøtt. Hvis antall endres må dyrene fordeles på nytt i returkjøtt-oppdelinger. Ønsker du å fortsette?',
      );

      if (!deleteReturnOptionsGroups) {
        return true; // we cannot proceed since the ammount of return meat is lower than the animals divided into return groups
      }
    }

    if (selectedAction === 'slaughter' && currentAnimalRow.return_meat_checked === true && int(currentAnimalRow.return_meat) === 0) {
      return 'Når returkjøtt er avhuket kan ikke antallet returkjøtt være 0';
    }

    let animalRowToAddUpdate = {
      subcategory_name: selectedAnimalSubGroup,
      club_no: currentAnimalRow.club_no,
      amount: currentAnimalRow.amount,
      mark_no: currentAnimalRow.mark_no,
      individual_no: currentAnimalRow.individual_no,
      comment: currentAnimalRow.comment,
      return_meat: currentAnimalRow.return_meat,
      has_health_remarks: currentAnimalRow.has_health_remarks,
      health_remarks_cnt: currentAnimalRow.health_remarks_cnt,
      health_remarks_groups: currentAnimalRow.health_remarks_groups,
    };

    animalRowToAddUpdate.uid = animalRowMode === 'add'
      ? getUIDForNewAnimalRow()
      : currentAnimalRow.uid;

    if (getFeaturesEnabled().return_form) {
      animalRowToAddUpdate.return_options_groups = currentAnimalRow.return_options_groups;

      if (animalRowToAddUpdate.return_meat < 0) {
        delete animalRowToAddUpdate.return_meat;
      }

      if (deleteReturnOptionsGroups) {
        // keep groups that are for existing animal rows, but delete others(for th)
        setReturnSlaughterOptionsGroups((groups) => groups.filter((g) => {
          const animalRowsNotThis = (animalRows || []).filter((ar, arIdx) => arIdx !== indexAnimalRowToEdit);

          // keep the groups if we have animal rows (not the one currently editing, beloging to this group)
          return animalRowsNotThis.find((ar) => (ar.return_options_groups || []).find((ag) => ag.group_id === g.id));
        }));

        delete animalRowToAddUpdate.return_options_groups;
      }
    }

    // add/remove ear tag and/or club_no when relevant
    // this is relevant when we do an edit so the animal switches from group pig
    // to individual pig or oposite
    if (isPigsWithIndividualRegistration()) {
      delete animalRowToAddUpdate.club_no;

      animalRowToAddUpdate.health_remarks_code = currentAnimalRow.health_remarks_code;
      animalRowToAddUpdate.health_remarks_comment = currentAnimalRow.health_remarks_comment;

      if (animalRowMode === 'edit') {
        animalRowToAddUpdate.ear_tag = currentAnimalRow.ear_tag;
        animalRowToAddUpdate.amount = 1;
      }
    } else {
      delete animalRowToAddUpdate.ear_tag;
    }
    animalRowToAddUpdate = removeHealthRemarksIfAnimalChanged(animalRowToAddUpdate);

    if (!animalRowToAddUpdate.has_health_remarks) {
      delete animalRowToAddUpdate.health_remarks_cnt;
    }

    // add each individual pigs as each own row
    if (animalRowMode === 'add' && isPigsWithIndividualRegistration()) {
      const toAdd = [];
      for (const [idx, individualPig] of currentAnimalRow.individual_pigs.filter((e) => !e.disabled).entries()) {
        const row = { ...individualPig };
        row.amount = 1;
        row.comment = animalRowToAddUpdate.comment;
        row.subcategory_name = animalRowToAddUpdate.subcategory_name;
        row.uid = getUIDForNewAnimalRow() + idx;

        toAdd.push(row);
      }
      addAnimalRows(toAdd);
    } else if (animalRowMode === 'edit') {
      updateAnimalRow(animalRowToAddUpdate, indexAnimalRowToEdit);
    } else {
      addAnimalRow(animalRowToAddUpdate);
    }

    return undefined;
  };

  const addEditSheepRow = () => {
    /*
      ============================
      SMÅFE
      ============================
    */
    const inputErrors = { ...currentAnimalRowInputErrors };

    if (selectedAction === 'slaughter') {
      inputErrors.individualNumbers = {};
      const foundWithErr = [];

      for (const returnSheep of getReturnSheep(currentAnimalRow)) {
        const invalid = !/^[0-9]{1,5}$/.test(returnSheep.individual_no) || returnSheep.individual_no === '00000';
        inputErrors.individualNumbers[returnSheep.individual_no] = invalid;

        if (invalid) {
          foundWithErr.push(1);
        }
      }

      if (foundWithErr.length === 0) {
        inputErrors.individualNumbers = false;
      }

      inputErrors.invalidReturn = {};
      const foundReturnWirhErr = [];

      for (const returnSheep of getReturnSheep(currentAnimalRow)) {
        const invalid = !returnSheep.return_skin && !returnSheep.return_meat;
        inputErrors.invalidReturn[returnSheep.individual_no] = invalid;

        if (invalid) {
          foundReturnWirhErr.push(1);
        }
      }

      if (foundReturnWirhErr.length === 0) {
        inputErrors.invalidReturn = false;
      }
    }

    if (selectedAction === 'sell') {
      inputErrors.sheep_individual_no = !/^[0-9]{1,5}$/.test(currentAnimalRow.sheep_individual_no) || currentAnimalRow.sheep_individual_no === '00000';
    }

    setCurrentAnimalRowInputErrors(inputErrors);

    if (!everyValueInObjectIsFalse(inputErrors)) {
      return true;
    }

    if (selectedAction === 'slaughter') {
      const individual_numbers = [];
      const duplicate = [];
      for (const returnSheep of getReturnSheep(currentAnimalRow)) {
        if (individual_numbers.indexOf(returnSheep.individual_no) >= 0) {
          duplicate.push(returnSheep.individual_no);
        }

        individual_numbers.push(returnSheep.individual_no);
      }
      if (duplicate.length > 0) {
        return `Det finnes flere sauer med samme individnummer: ${Array.from(new Set(duplicate)).join(', ')}`;
      }
    }

    const duplicate = [];
    if (selectedAction === 'slaughter') {
      for (const returnSheep of getReturnSheep(currentAnimalRow)) {
        for (const [index, row] of animalRows.entries()) {
          if (animalRowMode === 'edit' && index === indexAnimalRowToEdit) {
            continue;
          }

          if ((row.return_sheep || []).some((s) => s.individual_no === returnSheep.individual_no)) {
            duplicate.push(returnSheep.individual_no);
          }
        }
      }
      if (duplicate.length > 0) {
        return `Småfe med et eller flere av de valgte individnummerene er allerede lagt til: ${Array.from(new Set(duplicate)).join(', ')}`;
      }
    }

    if (selectedAction === 'slaughter' && animalRows
      .filter((_, i) => (animalRowMode === 'edit' ? i !== indexAnimalRowToEdit : true))
      .some((e) => e.subcategory_name === selectedAnimalSubGroup)
    ) {
      return 'Småfe av denne typen er allerede lagt til.';
    }

    if (
      (selectedAction === 'sell' || selectedAction === 'buy')
        && animalRows
          .filter((_, i) => (animalRowMode === 'edit' ? i !== indexAnimalRowToEdit : true))
          .some((e) => (selectedAction === 'sell'
            ? e.sheep_individual_no === currentAnimalRow.sheep_individual_no
            : e.sheep_kind === currentAnimalRow.sheep_kind
              && e.sheep_race === currentAnimalRow.sheep_race
              && currentAnimalRow.sheep_race !== 'Annen, se kommentar'))
    ) {
      return selectedAction === 'buy' ? 'Småfe av denne typen er allerede lagt til' : 'Dette småfeet er allerede lagt til.';
    }

    if (
      selectedAction === 'slaughter'
        && getReturnSheep(currentAnimalRow)
        && getReturnSheep(currentAnimalRow).length
        > int(currentAnimalRow.amount)
    ) {
      return 'Antall dyr med retur kan ikke være større enn antallet dyr.';
    }

    if (selectedAction === 'slaughter' && selectedAnimalGroup === 'sheep' && currentAnimalRow.return_sheep) {
      const maxAmountAnimalsWithaoutReturnHealthRemarks = parseInt(currentAnimalRow.amount, 10) - getReturnSheep(currentAnimalRow).length;
      if (parseInt(currentAnimalRow.health_remarks_cnt, 10) > maxAmountAnimalsWithaoutReturnHealthRemarks) {
        return `Antall dyr uten retur, med helseavvik kan ikke være større enn ${maxAmountAnimalsWithaoutReturnHealthRemarks}`;
      }
    }

    let animalRowToAddUpdate = {
      comment: currentAnimalRow.comment,
    };

    const addProviderAnimalKeepingToObject = (obj) => {
      if (profile.profile.animal_keeping_id) {
        obj.animal_keeping_id = profile.profile.animal_keeping_id;
      } else if (profile.profile.provider_no) {
        obj.provider_no = profile.profile.provider_no;
      }
      return obj;
    };

    if (selectedAction === 'slaughter' && animalRowMode === 'add') {
      const return_sheep = [];

      for (const returnSheep of getReturnSheep(currentAnimalRow)) {
        const row = { ...returnSheep };
        row.return_skin = !!row.return_skin;
        row.return_meat = !!row.return_meat;
        row.comment = currentAnimalRow.comment;
        row.amount = 1;
        row.subcategory_name = selectedAnimalSubGroup;
        row.is_sheep_cut = currentAnimalRow.is_sheep_cut;
        return_sheep.push(row);
      }

      const sheepToAdd = {
        comment: currentAnimalRow.comment,
        amount: currentAnimalRow.amount,
        subcategory_name: selectedAnimalSubGroup,
        is_sheep_cut: currentAnimalRow.is_sheep_cut,
        health_remarks_cnt: currentAnimalRow.health_remarks_cnt,
        has_health_remarks: currentAnimalRow.has_health_remarks,
      };

      sheepToAdd.return_sheep = return_sheep;
      sheepToAdd.return_meat = return_sheep.filter((e) => e.return_meat).length;
      sheepToAdd.return_skin = return_sheep.filter((e) => e.return_skin).length;

      addProviderAnimalKeepingToObject(sheepToAdd);
      addAnimalRow(sheepToAdd);
    }

    if (selectedAction === 'slaughter' && animalRowMode === 'edit') {
      animalRowToAddUpdate = {
        ...animalRowToAddUpdate,
        amount: currentAnimalRow.amount,
        subcategory_name: selectedAnimalSubGroup,
        is_sheep_cut: currentAnimalRow.is_sheep_cut,
        has_health_remarks: currentAnimalRow.has_health_remarks,
        health_remarks_cnt: currentAnimalRow.health_remarks_cnt,
        health_remarks_groups: currentAnimalRow.health_remarks_groups,
        return_sheep: currentAnimalRow.return_sheep.map((rs) => ({ ...rs, subcategory_name: selectedAnimalSubGroup })),
      };

      animalRowToAddUpdate = removeHealthRemarksIfAnimalChanged(animalRowToAddUpdate);

      if (!animalRowToAddUpdate.has_health_remarks) {
        delete animalRowToAddUpdate.health_remarks_groups;
      }

      if (animalRowToAddUpdate.subcategory_name === 'Kje') {
        delete animalRowToAddUpdate.is_sheep_cut;
      }

      addProviderAnimalKeepingToObject(animalRowToAddUpdate);
    }

    if (selectedAction === 'buy' || selectedAction === 'sell') {
      animalRowToAddUpdate = {
        ...animalRowToAddUpdate,
        sheep_kind: currentAnimalRow.sheep_kind,
        sheep_race: currentAnimalRow.sheep_race,
      };
    }

    if (selectedAction === 'buy') {
      animalRowToAddUpdate = {
        ...animalRowToAddUpdate,
        amount: currentAnimalRow.amount,
      };
    }

    if (selectedAction === 'sell') {
      animalRowToAddUpdate = {
        ...animalRowToAddUpdate,
        sheep_individual_no: currentAnimalRow.sheep_individual_no,
      };
    }

    if (selectedAction === 'buy' || selectedAction === 'sell') {
      if (animalRowMode === 'add') {
        addAnimalRow(animalRowToAddUpdate);
      } else if (animalRowMode === 'edit') {
        updateAnimalRow(animalRowToAddUpdate, indexAnimalRowToEdit);
      }
    }

    if (selectedAction === 'slaughter') {
      let returnSheep = getReturnSheep(animalRowToAddUpdate);

      if (getFeaturesEnabled().return_form && animalRowMode === 'edit') {
        returnSheep.forEach((rs, rsIdx) => {
          // if the sheep does not exist yet
          if (!animalRows[indexAnimalRowToEdit].return_sheep[rsIdx]) {
            return; // continue
          }

          const returnSheepChanged = getAnimalRowID(animalRows[indexAnimalRowToEdit].return_sheep[rsIdx]) !== getAnimalRowID(rs)
            || (selectedAnimalSubGroup !== animalRows[indexAnimalRowToEdit].return_sheep[rsIdx].subcategory_name);

          // new identify means we need to readd to return group
          if (returnSheepChanged) {
            delete returnSheep[rsIdx].return_options_groups;
          }
        });
      }

      if (Array.isArray(returnSheep)) {
        returnSheep = returnSheep.map((rs) => ({ ...rs, subcategory_name: selectedAnimalSubGroup }));
      }

      animalRowToAddUpdate.return_sheep = returnSheep;
      animalRowToAddUpdate.return_meat = returnSheep.filter((e) => e.return_meat).length;
      animalRowToAddUpdate.return_skin = returnSheep.filter((e) => e.return_skin).length;
    }

    if (animalRowMode === 'edit') {
      updateAnimalRow(animalRowToAddUpdate, indexAnimalRowToEdit);
    }

    return undefined;
  };

  const addEditCattleRow = () => {
    /*
      ============================
      STORFE
      ============================
    */
    if (selectedAction === 'buy' || selectedAction === 'sell') {
      const getCattleStr = (a) => String((a.live_animal_type || ''))
        + String((a.cattle_category || ''))
        + String((a.cattle_weight || ''))
        + String((a.cattle_gender || ''))
        + String((a.cattle_breeding_fertility_status || ''))
        + String((a.individual_no || ''))
        + String((a.uid || ''));

      const cattleStrs = animalRows.map(getCattleStr);
      const cattleToAddEditStr = getCattleStr(currentAnimalRow);

      if (
        (animalRowMode === 'add' && cattleStrs.indexOf(cattleToAddEditStr) >= 0)
        // if in edit mode, we do not want to match agains the row beeing edited
        || (animalRowMode === 'edit'
          && cattleStrs.filter((a, i) => i !== indexAnimalRowToEdit)
            .indexOf(cattleToAddEditStr) >= 0)
      ) {
        return 'Storfe av denne typen er allerede lagt til';
      }
    }
    if (animalRowMode === 'add') {
      if (selectedAction === 'buy') {
        addAnimalRow({
          animal_kind: selectedAnimalGroup,
          stepNoOnSubmit: currentStep,
          ...currentAnimalRow,
        });

        return undefined;
      }

      // cattle to be added are stored in the cattle-object in currentAnimalRow
      // each key in this object is created using its mark and individual number
      for (const cattleKey of Object.getOwnPropertyNames(currentAnimalRow.cattle)) {
        if (animalRows && animalRows.some((e) => e.mark_no === currentAnimalRow.cattle[cattleKey].mark_no
          && e.individual_no === currentAnimalRow.cattle[cattleKey].individual_no)
        ) {
          return 'En eller flere av de valgte storfeene er allerede lagt til';
        }
      }
    }

    if (animalRowMode === 'edit') {
      if (selectedAction === 'buy') {
        updateAnimalRow({ stepNoOnSubmit: currentStep, ...currentAnimalRow }, indexAnimalRowToEdit);

        return undefined;
      }

      if (
        animalRows && animalRows.filter((_, i) => i !== indexAnimalRowToEdit)
          .some((e) => e.mark_no === currentAnimalRow.mark_no && e.individual_no === currentAnimalRow.individual_no)
      ) {
        return 'En eller flere av de valgte storfeene er allerede lagt til';
      }

      let toUpdate = {
        subcategory_name: currentAnimalRow.subcategory_name,
        mark_no: currentAnimalRow.mark_no,
        comment: currentAnimalRow.comment,
        individual_no: currentAnimalRow.individual_no,
        return_meat: currentAnimalRow.return_meat,
        return_skin: currentAnimalRow.return_skin,
        has_health_remarks: currentAnimalRow.has_health_remarks,
        uid: getKeyForCattle(currentAnimalRow),
        health_remarks_code: currentAnimalRow.health_remarks_code,
        health_remarks_cnt: currentAnimalRow.health_remarks_cnt,
        health_remarks_comment: currentAnimalRow.health_remarks_comment,
      };

      if (getFeaturesEnabled().return_form) {
        toUpdate.return_options_groups = currentAnimalRow.return_options_groups;
      }
      if (selectedAction === 'sell') {
        toUpdate.horn = currentAnimalRow.horn;
        toUpdate.pregnant = currentAnimalRow.pregnant || false;
      }

      toUpdate = removeHealthRemarksIfAnimalChanged(toUpdate);

      updateAnimalRow(toUpdate, indexAnimalRowToEdit);
    } else {
      const rowsToAdd = [];

      for (const [i, cattleKey] of Object.getOwnPropertyNames(currentAnimalRow.cattle).entries()) {
        const cattle = currentAnimalRow.cattle[cattleKey];

        const toAdd = {
          subcategory_name: cattle.subcategory_name.toLowerCase(),
          mark_no: cattle.mark_no,
          comment: cattle.comment,
          individual_no: cattle.individual_no,
          return_skin: cattle.return_skin,
          return_meat: cattle.return_meat,
          has_health_remarks: cattle.has_health_remarks,
          health_remarks_code: currentAnimalRow.health_remarks_code,
          health_remarks_cnt: currentAnimalRow.health_remarks_cnt,
          uid: getUIDForNewAnimalRow() + i,
        };

        if (selectedAction === 'sell') {
          toAdd.horn = cattle.horn;
          toAdd.pregnant = cattle.pregnant || false;
        }
        rowsToAdd.push(toAdd);
      }

      // add multiple at once to ensure all gets registered
      addAnimalRows(rowsToAdd);
    }

    return undefined;
  };

  // Check if current row is valid and if so clean data for the row and add it to the rows
  const onAddEditAnimalRow = () => {
    let err = validateAddEditAnimalRow();

    if (err) {
      if (typeof err === 'string') {
        setCurrentAnimalRowErrorMsg(err);
      }
      return;
    }

    if (selectedAnimalGroup === 'pigs') {
      err = addEditPigRow();
    } else if (selectedAnimalGroup === 'sheep') {
      err = addEditSheepRow();
    } else if (selectedAnimalGroup === 'cattle') {
      err = addEditCattleRow();
    }

    if (typeof err === 'string') {
      setCurrentAnimalRowErrorMsg(err);
    } else if (!err) {
      resetAnimalRow();
    }
  };

  const onEditAnimalRow = (index) => {
    setAnimalRowMode('edit');
    setIndexAnimalRowToEdit(index);

    if (isRegularAnimalFlow()) {
      scrollToElement(refElemStartOfRegularEnrolmentFlow.current, true);
    } else {
      scrollToElement(refElemStartOfCustomEnrolmentFlow.current, true);
    }
    const currAnimalRowCopy = { ...animalRows[index] };
    currAnimalRowCopy.showComment = false;

    if (selectedAction === 'buy' && selectedAnimalGroup === 'cattle') {
      setCurrentStep(animalRows[index].stepNoOnSubmit);
    }

    if (selectedAnimalGroup === 'pigs' && animalRows[index].return_meat > 0) {
      currAnimalRowCopy.return_meat_checked = true;
    }
    setCurrentAnimalRow(currAnimalRowCopy);

    if (animalRows[index] && animalRows[index].subcategory_name) {
      // ignore ung/young versions of the subcategory name
      setSelectedAnimalSubGroup(animalRows[index].subcategory_name.split('ung ').slice(-1)[0]);
    }
  };

  const onDeleteAnimalRow = (index) => {
    setIndexAnimalRowToShowDeleteConfirmation(index);
  };

  const resetAnimalRow = () => {
    if (selectedAction === 'buy') {
      setCurrentStep(2);
    }
    setChoosedCattleIDsFromDropdowIndexesByKind({});
    setAnimalRowMode('add');
    setIndexAnimalRowToShowDeleteConfirmation(-1);
    setCurrentAnimalRow({});
    setCurrentAnimalRowInputErrors({});
    setIndexAnimalRowToEdit(-1);
    setCurrentAnimalRowErrorMsg(null);
    setSelectedAnimalSubGroup(null);
    setAnimalRowShowAddComment(false);
  };

  const resetRegistrationProgressForCurrAnimal = () => {
    setAnimalRows([]);
    setSelectedAnimalSubGroup(null);
    setCurrentAnimalRow({});
    setCurrentAnimalRowErrorMsg(null);
    setAnimalRowMode('add');
    setChoosedCattleIDsFromDropdowIndexesByKind({});
    setReturnSlaughterOptionsGroups([]);
    setReturnSlaughterOptionsCommon({});
    setReturnSlaughterOptionsCommentMeat(null);
    setReturnSlaughterOptionsCommentSkin(null);
  };

  // when we have checked that all is OK, this will register the enrolment to the backend
  const onSubmitEnrolment = () => {
    // the user has left the enrolment page open and
    // it is pherhaps no longer valid
    if (!getRegistrationReadyForSending()) {
      toast.addError('Innmeldingen er ikke lenger gyldig.');
      return;
    }

    const dataBuySell = {
      animal_category: selectedAnimalGroup,
      animal_rows: animalRows,
      wanted_pickup_week,
      wanted_pickup_year,
      comment,
    };

    if (selectedAction === 'sell' || selectedAction === 'buy') {
      dispatch(
        enrollmentActions.saveEnrolment({
          kind: selectedAction,
          enrolment: dataBuySell,
          onSuccess: (resp) => {
            if (resp.registered === true) {
              localStorage.setItem('sw-enrollment', null);
              toast.addMessage('Innmeldingen ble registrert');
              dispatch(enrollmentActions.resetEnrolmentDates());
              dispatch(enrollmentActions.resetStoredState());
              push(routes.registeredEnrolments);
            }
            if (helsegrisCheckEnabled && resp.helsegris_ok === false) {
              document.body.scrollTop = 0;
              document.documentElement.scrollTop = 0;
            }
          },
          onError: (status) => {
            if (status === 503) {
              toast.addMessage(
                'Kunne ikke registrere innmeldingen akkuratt nå. Vennligst prøv igjen om en liten stund.',
                5000,
              );
            } else {
              toast.addMessage('Kunne ikke registrere innmeldingen');
            }
          },
        }),
      );

      setConfirmAnimalsNotInCrowdWithinWeek(false);
      setConfirmAnimalsNotInCrowd(false);
      setConfirm_group_medications_restrain_limit_within_week(false);
      setConfirmGroupDiseaseMedicationAfterWeek(false);
      return;
    }

    const data = {
      animal_category: selectedAnimalGroup,
      wanted_pickup_week,
      wanted_pickup_year,
      confirm_group_disease_medication_after_week,
      confirm_group_medications_restrain_limit_within_week,
      confirm_animals_not_in_crowd,
      confirm_animals_not_in_crowd_within_week,
      confirm_choosen_animal_medications_restrain_limit_within_week,
      confirm_textual_animal_ids_within_week_ok,
      confirm_textual_animal_ids_medication_ok,
      comment,
    };

    if (getFeaturesEnabled().pickup_location_for_return_meat) {
      data.return_meat_pickup_location = return_meat_pickup_location;
    }
    if (selectedAnimalGroup === 'cattle') {
      data.pickup_on_cattle_agreement = pickup_on_cattle_agrement;
    }
    if (selectedAnimalGroup === 'sheep' || selectedAnimalGroup === 'cattle') {
      data.want_marks_sent_on_return = wantMarksSentOnReturn && getAnimalRowsHasOneOrMoreReturn();
    }

    // add animal rows to the enrolment
    const animalRowsCopy = [...animalRows];
    const rowsToSubmit = [];
    for (let i = 0; i < animalRowsCopy.length; i++) {
      const animalCopy = { ...animalRowsCopy[i] };

      // animals registered in group have return meat set as amount
      if (selectedAnimalGroup === 'pigs' && animalCopy.return_meat === undefined) {
        animalCopy.return_meat = 0;
      }

      // animals registered individually animals have return meat set as true or false (exeption for sheep bellow)
      if (
        selectedAnimalGroup === 'pigs'
          && getFeaturesEnabled().purke_raane_individual_registration
          && ['purke', 'råne'].indexOf(animalCopy.subcategory_name.toLowerCase()) >= 0
      ) {
        animalCopy.ear_tag = animalCopy.ear_tag || null;
        if (!animalCopy.return_meat) {
          animalCopy.return_meat = false;
        }
      }

      // individual animals with return meat/skin for sheep are added into return_skin_meat
      if (selectedAnimalGroup === 'sheep') {
        delete animalCopy.return_meat;
        delete animalCopy.return_skin;
        animalCopy.return_skin_meat = animalCopy.return_sheep.filter(
          (e) => !e.disabled && (e.return_skin || e.return_meat),
        );
        delete animalCopy.return_sheep;
      }
      if (selectedAnimalGroup === 'cattle' && animalCopy.return_meat === undefined) {
        animalCopy.return_meat = false;
      }
      if (selectedAnimalGroup === 'cattle' && animalCopy.return_skin === undefined) {
        animalCopy.return_skin = false;
      }
      delete animalCopy.uid;
      delete animalCopy.hidden;
      delete animalCopy.returnMeatCountInput;
      delete animalCopy.returnSkinCountInput;
      rowsToSubmit.push(animalCopy);
    }

    if (getFeaturesEnabled().return_form) {
    // for commn fields set default radio-group data(the first radio-button in each group), if not selected explicitly
      // this is because these fields are only selected visually, so we need to store the value  if not selected by the user
      function setFirstCommonRadioGroupItemAsSelected(type) {
        if ([...getAnimalRowsWithReturn(type, animalRowsCopy)].length > 0) {
          (returnSlaughterOptionsForm.data.form_fields[type === 'return_skin' ? 'common-skin' : 'common-meat'] || [])
            .forEach((field, idx, arr) => {
              if (field.kind !== 'radio-group') {
                return; // continue
              }
              const userHasSelected = field.radio_buttons.filter((rb) => returnSlaughterOptionsCommonCopy[rb.id] !== undefined).length > 0;
              if (userHasSelected) {
                return; // continue
              }

              // now we know the user has not selected it, so set first in group as checked
              returnSlaughterOptionsCommonCopy[field.radio_buttons[0].id] = true;
            });
        }
      }

      const returnSlaughterOptionsCommonCopy = { ...returnSlaughterOptionsCommon };

      setFirstCommonRadioGroupItemAsSelected('return_skin');
      setFirstCommonRadioGroupItemAsSelected('return_meat');
      data.returnSlaughterOptionsCommon = returnSlaughterOptionsCommonCopy;

      if (returnSlaughterOptionsForm.data) {
        data.return_form_fields = returnSlaughterOptionsForm.data?.form_fields;
        data['return_form_illegal-checkbox-combinations'] = returnSlaughterOptionsForm.data['illegal-checkbox-combinations'];
      }
      data.animal_rows = rowsToSubmit;

      data.returnSlaughterOptionsGroups = returnSlaughterOptionsGroups;
      data.returnSlaughterOptionsCommentSkin = returnSlaughterOptionsCommentSkin;
      data.returnSlaughterOptionsCommentMeat = returnSlaughterOptionsCommentMeat;

      // if any group still not have any data, inform the user
      if (returnSlaughterOptionsGroups.filter((g) => !g.formData || everyValueInObjectIsFalse(g.formData)).length > 0) {
        toast.addError('En eller flere oppdelings-grupper mangler form for retur-slakt.', 6000);
        return;
      }
    } else {
      data.animal_rows = rowsToSubmit;
    }

    dispatch(
      enrollmentActions.saveEnrolment({
        enrolment: data,
        kind: 'slaughter',
        onSuccess: (resp) => {
          if (resp.registered === true) {
            localStorage.setItem('sw-enrollment', null);
            dispatch(enrollmentActions.resetStoredState());
            dispatch(enrollmentActions.resetEnrolmentDates());
            toast.addMessage('Innmeldingen ble registrert');
            push(routes.registeredEnrolments);
          }
          if (helsegrisCheckEnabled && resp.helsegris_ok === false) {
            document.body.scrollTop = 0;
            document.documentElement.scrollTop = 0;
          }
          if (resp.ksl_ok === false) {
            document.body.scrollTop = 0;
            document.documentElement.scrollTop = 0;
          }
        },
        onError: (status) => {
          if (status === 503) {
            toast.addMessage(
              'Kunne ikke registrere innmeldingen akkuratt nå. Vennligst prøv igjen om en liten stund.',
              5000,
            );
          } else {
            toast.addMessage('Kunne ikke registrere innmeldingen');
          }
        },
      }),
    );

    setConfirmAnimalsNotInCrowdWithinWeek(false);
    setConfirmAnimalsNotInCrowd(false);
    setConfirm_group_medications_restrain_limit_within_week(false);
    setConfirmGroupDiseaseMedicationAfterWeek(false);
  };

  const getAnimalRowsHasOneOrMoreReturn = ({ returnMeatOnly } = {}) => {
    for (const row of animalRows) {
      if ((!returnMeatOnly && row.return_skin) || row.return_meat) {
        return true;
      }
      if (row.return_sheep && row.return_sheep.some((s) => s.return_meat || (!returnMeatOnly && s.return_skin))) {
        return true;
      }
    }
    return false;
  };

  const getAnimalRowsHasOneOrMoreHealthRemarks = () => animalRows.find((a) => a.health_remarks_cnt > 0 || a.has_health_remarks || (a.return_sheep && a.return_sheep.find((r) => r.has_health_remarks)));

  const getPickupDateWording = () => {
    if (selectedAction === 'slaughter') {
      if (selectedAnimalGroup === 'cattle') return 'Ønsket basisuke';
      return 'Ønsket hentedato';
    }
    if (selectedAction === 'buy') {
      return 'Ønsket leveringsdato';
    }

    if (selectedAction === 'sell') {
      return 'Ønsket hentedato';
    }

    return null;
  };

  const moveAnimalsToReturnSlaughterOptionsGroup = ({
    animal_rows_to_move,
    moveFromGroupId,
    moveToGroupId,
    newGroup,
  }) => {
    const copyOfAnimalRows = [...animalRows];
    let copyOfGroups = [...returnSlaughterOptionsGroups];

    const animalIdsToMove = animal_rows_to_move.map((a) => getAnimalRowID(a));

    const performMove = (animalRow, animalRowIdx, returnSheepIdx, from, to) => {
      let returnOptionsGroups = [];
      if (returnSheepIdx) {
        returnOptionsGroups = copyOfAnimalRows[animalRowIdx].return_sheep[returnSheepIdx].return_options_groups;
      } else {
        returnOptionsGroups = copyOfAnimalRows[animalRowIdx].return_options_groups;
      }
      if (!returnOptionsGroups) {
        returnOptionsGroups = [];
      }

      // if not this animal row is relevant, skip it
      if (!animalIdsToMove.includes(getAnimalRowID(animalRow)) || (!animalRow.return_meat && !animalRow.return_skin)) {
        return; // continue
      }

      // remove empty groups
      returnOptionsGroups = returnOptionsGroups.filter((g) => g.amount_animals > 0);

      // add the animal to the new group
      returnOptionsGroups = returnOptionsGroups.concat(({ group_id: to, amount_animals: 1 }));

      if (returnSheepIdx !== null) {
        copyOfAnimalRows[animalRowIdx].return_sheep[returnSheepIdx].return_options_groups = returnOptionsGroups;
      } else {
        copyOfAnimalRows[animalRowIdx].return_options_groups = returnOptionsGroups;
      }
    };

    animalRows.forEach((ar, idx) => {
      if (ar.club_no && ar.return_meat) {
        // handle each return meat as a separate animal, since it can have its own group
        Array.from(Array(+ar.return_meat).keys()).map((_, idxInClub) => {
          const animalInClub = { ...ar };
          animalInClub.idx_in_club = idxInClub;
          performMove(animalInClub, idx, null, moveFromGroupId, moveToGroupId);
        });
      }
      if (ar.return_sheep) {
        copyOfAnimalRows[idx].return_sheep.forEach((rs, rsIdx) => {
          performMove({ ...rs, subcategory_name: ar.subcategory_name }, idx, rsIdx, moveFromGroupId, moveToGroupId);
        });
      } else {
        performMove(ar, idx, null, moveFromGroupId, moveToGroupId);
      }
    });

    if (newGroup) {
      copyOfGroups = copyOfGroups.concat([{ id: newGroup.id, divisionNo: newGroup.divisionNo }]);
    }
    // because of moving animals, some groups may now be empty
    // and we want to delete those and only keep those that exists in any animal rows
    copyOfGroups = copyOfGroups.filter((g) => copyOfAnimalRows.find((a) => {
      if (selectedAnimalGroup === 'pigs' || selectedAnimalGroup === 'cattle') {
        return (a.return_options_groups || []).find((ag) => ag.group_id === g.id && ag.amount_animals > 0);
      } else if (selectedAnimalGroup === 'sheep') {
        return a.return_sheep.find((rs) => (rs.return_options_groups || []).find((ag) => ag.group_id === g.id && ag.amount_animals > 0));
      }
    }));

    setReturnSlaughterOptionsGroups(copyOfGroups);
    setAnimalRows(copyOfAnimalRows);
  };

  const deleteReturnSlaughterOptionsGroup = ({ groupId }) => {
    // remove the group for all animals in this group
    const copyOfAnimalRows = [...animalRows];
    const groupsDeleted = [...returnSlaughterOptionsGroups].filter((g) => g.id !== groupId);

    animalRows.forEach((ar, idx) => {
      if (ar.return_sheep) {
        copyOfAnimalRows[idx].return_sheep.forEach((rs, rsIdx) => {
          if (!Array.isArray(copyOfAnimalRows[idx].return_sheep[rsIdx].return_options_groups)) {
            return; // continue
          }
          copyOfAnimalRows[idx].return_sheep[rsIdx].return_options_groups = copyOfAnimalRows[idx].return_sheep[rsIdx].return_options_groups.filter((ar) => ar.group_id !== groupId);
        });
      } else {
        if (!Array.isArray(ar.return_options_groups)) {
          return; // continue
        }
        copyOfAnimalRows[idx].return_options_groups = ar.return_options_groups.filter((ar) => ar.group_id !== groupId);
      }
    });
    setAnimalRows(copyOfAnimalRows);
    setReturnSlaughterOptionsGroups(groupsDeleted);
  };

  const changeCommentForReturnSlaughterOptionsMeat = (comment) => {
    setReturnSlaughterOptionsCommentMeat(comment);
  };

  const changeCommentForReturnSlaughterOptionsSkin = (comment) => {
    setReturnSlaughterOptionsCommentSkin(comment);
  };

  const updateFormValueInReturnsSlaughterOptions = ({
    groupId, fieldId, uncheckFieldIds, value,
  }) => {
    const uncheck = uncheckFieldIds;

    if (groupId) {
      const copy = JSON.parse(JSON.stringify(returnSlaughterOptionsGroups)) || [];
      const targetIdx = copy?.findIndex?.((g) => g.id === groupId);

      const isFirstInput = Object.keys(copy?.[targetIdx]?.formData || {}).length === 0;

      copy[targetIdx] = {
        ...copy[targetIdx],
        formData: {
          ...copy[targetIdx]?.formData || {},
          ...isFirstInput && { whole: true },
          [fieldId]: value,
        },
      };

      if (uncheck?.length) {
        uncheck.forEach((id) => {
          if (copy?.formData?.[id] !== undefined) {
            delete copy.formData[id];
          }
          if (copy?.[targetIdx]?.formData?.[id] !== undefined) {
            delete copy[targetIdx].formData[id];
          }
        });
      }

      setReturnSlaughterOptionsGroups(copy);
    } else {
      const copy = { ...returnSlaughterOptionsCommon };

      if (uncheck?.length) {
        uncheck.forEach((id) => {
          delete copy[id];
        });
      }

      setReturnSlaughterOptionsCommon({
        ...copy,
        [fieldId]: value,
      });
    }
  };

  // try to submit current animal row on enter press, if valid
  useEffect(() => {
    const onKeyUp = (evt) => {
      if (evt.key === 'Enter' && evt.target.tagName !== 'TEXTAREA') {
        if (getCurrentAnimalRowIsValid()) {
          onAddEditAnimalRow();
        }
      }
    };

    document.addEventListener('keyup', onKeyUp);

    return () => document.removeEventListener('keyup', onKeyUp);
  });

  const userHasAnimalKinds = animals?.animals?.cattle?.length
    /* Ignore the ung/young part */
    ? animals.animals.cattle.map((a) => ignoreYougPartOfCattleKind(a.subcategory_name))
    : [];

  const getInfoForSelectedPickupWeek = () => ((((pickupWeeks.pickupWeeks || [])[selectedAction] || [])[
    selectedAnimalGroup
  ] || [])[wanted_pickup_year] || [])[wanted_pickup_week] || null;

  const isSelectedWeekAndYearValidForPickup = () => {
    // if the week are listed explicit as allowed or if the week is not in the list, it is allowed
    const weeks = getInfoForSelectedPickupWeek();
    if (pickup_on_cattle_agrement && selectedAnimalGroup === 'cattle') {
      if (weeks) {
        return weeks.allowedCattleDeal;
      } else {
        return true;
      }
    } else {
      if (weeks) {
        return weeks.allowed;
      } else {
        return true;
      }
    }
  };

  const getGoneOverDeadlineForDefaultWeek = (animalGroup, week, year) => {
    let timeInWeekIsCorrect = true;

    const [defaultYear, defaultWeek] = getDefaultBasisYearAndWeekForSelected(
      selectedAnimalGroup || animalGroup, pickup_on_cattle_agrement,
    );

    const slaughterRegistrationDeadline = getSlaughterRegistrationDeadline(pickup_on_cattle_agrement ? 'cattleAgreement' :  `${selectedAnimalGroup}_${selectedAction}` ) ||  getSlaughterRegistrationDeadline(pickup_on_cattle_agrement ? 'cattleAgreement' : 'normal');
    console.log({slaughterRegistrationDeadline});

    const defaultWeekLimit = getCurrentMoment()
      .year(defaultYear)
      .week(defaultWeek)
      .isoWeekday(slaughterRegistrationDeadline?.weekday)
      .set({ hour: slaughterRegistrationDeadline?.hour, minute: slaughterRegistrationDeadline?.minute, second: '0' });

    if (
      (week || wanted_pickup_week) === defaultWeek
        && (year || wanted_pickup_year) === defaultYear
        && getCurrentMoment()
          .year(defaultYear)
          .week(defaultWeek)
          .isoWeekday(getCurrentMoment().isoWeekday())
          .isAfter(defaultWeekLimit)
    ) {
      timeInWeekIsCorrect = false;
    }

    return !timeInWeekIsCorrect;
  };

  const getIsWantedPickupBasisWeekValid = ([year, week]) => {
    const [defaultYear, defaultWeek] = getDefaultBasisYearAndWeekForSelected(selectedAnimalGroup, pickup_on_cattle_agrement);

    return (!Number.isNaN(week) // is a number
      && wanted_pickup_week % 1 === 0 // is not a float numnber
      && week >= 1
      && (week > getCurrentWeek() || parseInt(year, 10) !== getCurrentYear())
      && week <= weeksInYear(year)
      && !getGoneOverDeadlineForDefaultWeek()
      && !momentByWeekAndYear(week, year).isBefore(momentByWeekAndYear(defaultWeek, defaultYear))
      && isSelectedWeekAndYearValidForPickup()
    );
  };

  const isLoading = animals.isFetching
    || profile.isFetching
    || animalKeeping.isFetching
    || pickupWeeks.isFetching;

  const errorLoadingRequisites = animals.error || profile.error || animalKeeping.error || pickupWeeks.error;

  const getIndexByReverseIndex = (reverseIndex) => animalRows.length - 1 - reverseIndex;

  const hasMissingAnimalKeeping = animalKeeping
    && animalKeeping.animalKeeping
    && !animalKeeping.animalKeeping.sheep
    && !animalKeeping.animalKeeping.cattle
    && !animalKeeping.animalKeeping.pigs;

  const noAnimalKeepingForSelectedAnimal = saveEnrolment
    && !saveEnrolment.error
    && !saveEnrolment.isFeteching
    && saveEnrolment.response
    && saveEnrolment.response.has_animal_group
    && saveEnrolment.response.has_animal_group === false;

  const hasInvalidKslStatus = (animalKeeping
      && animalKeeping.animalKeeping
      && animalKeeping.animalKeeping.ksl_status !== 'green')
    || (saveEnrolment
      && !saveEnrolment.isFetching
      && saveEnrolment.response
      && saveEnrolment.response.ksl_ok === false);

  const hasInvalidHelsegrisStatus = (animalKeeping?.animalKeeping?.helsegris_ok === false)
    || (!saveEnrolment?.isFetching && saveEnrolment?.response?.helsegris_ok === false);

  const hasRestrictionsForAnimalFromServer = saveEnrolment
    && !saveEnrolment.isFetching
    && !saveEnrolment.error
    && saveEnrolment.response
    && saveEnrolment.response.has_restrictions_for_group;

  const ableToRegisterExcludingRestrictions = !hasMissingAnimalKeeping
    && !hasInvalidKslStatus
    && !noAnimalKeepingForSelectedAnimal;

  const hasStoredLocalState = () => !!(
    storedLocalstorageState && storedLocalstorageState.state
      && (storedLocalstorageState.state.selectedAnimalGroup || (storedLocalstorageState.state.animalRows && storedLocalstorageState.state.animalRows.length > 0))
  );

  const helsegrisCheckEnabled = getFeaturesEnabled()['helsegris-check'];

  const hasStoredServerState = () => storedStateOnServer.storedState
    && Object.getOwnPropertyNames(storedStateOnServer.storedState).length > 0;

  const hasStoredState = () => hasStoredLocalState() || hasStoredServerState();

  const hasMissingAnimalKeepingFromRegistration = selectedAction === 'slaughter'
    && saveEnrolment
    && saveEnrolment.response
    && saveEnrolment.response.has_animal_group === false;

  const editCommentForCurrAnimalRowProps = {
    maxLength: maxCharactersCommentAnimal,
    showComment: animalRowMode === 'add'
      ? animalRowShowAddComment
      : animalRows[indexAnimalRowToEdit]
        ?.comment || animalRowShowAddComment,
    comment: currentAnimalRow.comment,
    onChangeComment: (comment) => setCurrentAnimalRow((old) => ({ ...old, comment })),
  };

  const shouldShowReturnMeatPickupLocationEdit = selectedAction === 'slaughter'
    && getFeaturesEnabled().pickup_location_for_return_meat
    && getAnimalRowsHasOneOrMoreReturn({ returnMeatOnly: true });

  const shouldShowReturnFormMeat = getAnimalRowsWithReturn('return_meat', animalRows).length > 0;
  const shouldShowReturnFormSkin = getAnimalRowsWithReturn('return_skin', animalRows).length > 0;

  return (
    <RegisterSlaughterPage title="Innmeldinger">
      <Breadcrumbs
        breadcrumbs={[{ title: 'Innmeldinger', url: '/register-enrolment' }]}
        wrapperStyle={css`
          margin-left: 1.2rem;
          margin-bottom: 1.5rem;
        `}
      />

      {!hasInvalidKslStatus
        && !(restrictionsForAnimal && selectedAction === 'slaughter')
        && !hasMissingAnimalKeeping && (
          <MainHeader ieHeightAdjust={selectedAnimalGroup} push={push} pathname={pathname} />
      )}

      {(isLoading && (
        <LoadingIndicator
          withText
          style={{ position: 'absolute', top: '4em' }}
        />
      )) || (errorLoadingRequisites && <LoadingErrorMessage />) || (
        <>
          {hasInvalidKslStatus && (
            <RegNotAvailibleInfo
              header="Ikke godkjent KSL-status"
              subject="Hei. Du har ikke en godkjent KSL-status."
              description={` For å levere til ${getBrandingText('companyName')} kreves det en gyldig KSL-status.
              Vennligst besøk matmerk.no for å lukke dine avvik.`}
            />
          )}

          {selectedAnimalGroup === 'pigs' && hasInvalidHelsegrisStatus && helsegrisCheckEnabled && (
            <RegNotAvailibleInfo subject= "Hei. Du har ikke godkjent status for Helsegris" />
          )}

          {(hasMissingAnimalKeepingFromRegistration || hasMissingAnimalKeeping) && (
            <RegNotAvailibleInfo
              header="Manglende dyrehold"
              subject={`Hei. Du har ikke registrert dyrehold ${hasMissingAnimalKeepingFromRegistration ? 'for valgt dyr' : ''} hos Mattilsynet.${' '}`}
              description="Registrer dyrehold for å kunne levere slakt."
            />
          )}

          {noAnimalKeepingForSelectedAnimal && (
            <RegNotAvailibleInfo
              header="Manglende dyrehold"
              subject={`
                  Hei. Du har ikke registrert dyrehold for${' '}
                  ${animalKindToNorwegian(selectedAnimalGroup)} hos
                  Mattilsynet.${' '}
                `}
              description="Registrer dyrehold for å kunne levere slakt."
            />
          )}
          {(restrictionsForAnimal || hasRestrictionsForAnimalFromServer) && (
            <RegNotAvailibleInfo
              header="Restriksjoner"
              subject={`Du har restriksjoner på${' '}${restrictionsForAnimal && false
                ? animalKindToNorwegian(restrictionsForAnimal)
                : animalKindToNorwegian(selectedAnimalGroup)}${' '}som tilsier at du ikke får lov til å levere slakt/kjøpe/selge.${' '}`}
              description="Vennligst ta kontakt med lokalt Mattilsyn eller slakteri former informasjon."
            />
          )}

          {ableToRegisterExcludingRestrictions
            && hasStoredState()
            && !hasChoosedRestoreAction && (
              <Modal>
                <Label size="1.5em" padding="1.5em">
                  Du har en innmelding du har begynt på, men som ikke er sendt
                  inn. Ønsker du å fortsette på denne?
                </Label>

                <div
                  style={{
                    display: 'flex',
                    flexDirection: 'row',
                    fontSize: '1.4em',
                    justifyContent: 'center',
                    flexWrap: 'wrap',
                  }}
                >
                  <ModalCancelButton
                    onClick={() => {
                      setHasChoosedRestoreAction(true);
                      dispatch(enrollmentActions.resetStoredState());
                      localStorage.removeItem('sw-enrollment');
                    }}
                  >
                    Nei, start på nytt
                  </ModalCancelButton>
                  <Button
                    primary
                    style={{
                      marginLeft: '1em',
                      padding: '12px 41px',
                    }}
                    onClick={() => {
                      const restoreLocal = () => {
                        restoreState(storedLocalstorageState.state);
                      };

                      const restoreServer = () => {
                        restoreState(storedStateOnServer.storedState.state);
                      };

                      if (hasStoredLocalState() && hasStoredServerState()) {
                        const localMoment = moment(
                          storedLocalstorageState.lastUpdated.replace(
                            ' . ',
                            ' ',
                          ),
                          'DD.MM-YYYY HH:mm:ss',
                        );
                        const serverMoment = moment(
                          storedStateOnServer.storedState.lastUpdated.replace(
                            ' . ',
                            ' ',
                          ),
                          'DD.MM-YYYY HH:mm:ss',
                        );

                        if (serverMoment.isAfter(localMoment)) {
                          restoreServer();
                        } else {
                          restoreLocal();
                        }
                      } else if (hasStoredLocalState()) {
                        restoreLocal();
                      } else if (hasStoredServerState()) { // from server
                        restoreServer();
                      }
                      setHasChoosedRestoreAction(true);
                    }}
                  >
                    Ja
                  </Button>
                </div>
              </Modal>
          )}

          {ableToRegisterExcludingRestrictions
            && !hasRestrictionsForAnimalFromServer
            && (!hasStoredState() || hasChoosedRestoreAction) && (
              <StepWrapper padding="0 1em" marginBottom="70px">
                <RegisterStep
                  name="step_1"
                  stepNo={1}
                  stepHeader="Hva gjelder innmeldingen?"
                  selectedValue={selectedAction}
                  choices={['Slakt', 'Kjøp livdyr', 'Selg livdyr']}
                  disabledValues={[]}
                  values={['slaughter', 'buy', 'sell']}
                  value={selectedAction}
                  style
                  onChange={(selected) => {
                    onClickStep(1);
                    const registrationInProgresss = Object.getOwnPropertyNames(currentAnimalRow).length > 0
                      || animalRows.length > 0
                      || selectedAnimalSubGroup;
                    if (registrationInProgresss) {
                      setShowPromptSwitchToActionResetProgress(selected);
                      return;
                    }
                    setSelectedAnimalGroup(null);
                    setSelectedAction(selected);
                    setCurrentAnimalRowInputErrors({});
                    setCurrentAnimalRowErrorMsg(null);
                  }}
                />

                {currentStep > 0 && (
                  <RegisterStep
                    ref={(current) => scrollToMe('step2', current)}
                    name="step_2"
                    stepNo={2}
                    stepHeader={selectedAction === 'slaughter'
                      ? 'Velg innmeldingsgruppe'
                      : selectedAction === 'buy'
                        ? 'Velg gruppe for kjøp:'
                        : 'Velg gruppe for salg:'}
                    selectedValue={selectedAnimalGroup}
                    choices={[
                      <AnimalKindIcon kind="pigs" />,
                      <AnimalKindIcon kind="sheep" />,
                      <AnimalKindIcon kind="cattle" />,
                    ]}
                    values={['pigs', 'sheep', 'cattle']}
                    smallInputChoices
                    disabledValues={selectedAction
                      ? (!animalKeeping.animalKeeping.cattle
                        ? ['cattle']
                        : []
                      )
                        .concat(
                          !animalKeeping.animalKeeping.sheep
                            ? ['sheep']
                            : [],
                        )
                        .concat(
                          !animalKeeping.animalKeeping.pigs
                            ? ['pigs']
                            : [],
                        )
                      : []}
                    onChange={(selected) => {
                      onClickStep(2);

                      let [year, week] = getDefaultBasisYearAndWeekForSelected(selected, pickup_on_cattle_agrement);
                      if (getGoneOverDeadlineForDefaultWeek(selected, week, year)) {
                        [year, week] = incrementWeek(year, week);
                      }
                      setWantedPickupBasisYear(year);
                      setWantedPickupWeek(week);

                      const registrationInProgresss = Object.getOwnPropertyNames(currentAnimalRow).length > 0
                        || animalRows.length > 0
                        || selectedAnimalSubGroup;

                      if (registrationInProgresss) {
                        setShowPromptSwitchToCategoryResetProgress(selected);
                        return;
                      }

                      if (animalKeeping.animalKeeping.restrictions[selected.toLowerCase()]) {
                        setRestrictionsForAnimal(selected);
                        setSelectedAnimalGroup(selected);
                        return;
                      } else {
                        setRestrictionsForAnimal(null);
                      }
                      setSelectedAnimalGroup(selected);
                      resetRegistrationProgressForCurrAnimal();
                      setCurrentAnimalRowInputErrors({});
                      setCurrentAnimalRowErrorMsg(null);
                    }}
                  />
                )}

                {(showPromptSwitchToCategoryResetProgress || showPromptSwitchToActionResetProgress) && (
                  <PromptConfirmReset
                    selectedAction={selectedAction}
                    showPromptSwitchToCategoryResetProgress={showPromptSwitchToCategoryResetProgress}
                    showPromptSwitchToActionResetProgress={showPromptSwitchToActionResetProgress}
                    onCancel={() => {
                      setShowPromptSwitchToCategoryResetProgress(null);
                      setShowPromptSwitchToActionResetProgress(null);
                    }}
                    onConfirm={() => {
                      dispatch(enrollmentActions.resetStoredState());
                      setCurrentAnimalRowInputErrors({});
                      setCurrentAnimalRowErrorMsg(null);

                      if (showPromptSwitchToCategoryResetProgress) {
                        setShowPromptSwitchToCategoryResetProgress(null);
                        setSelectedAnimalGroup(showPromptSwitchToCategoryResetProgress);
                        resetRegistrationProgressForCurrAnimal();
                        setCurrentStep(2);
                      }
                      if (showPromptSwitchToActionResetProgress) {
                        setSelectedAction(showPromptSwitchToActionResetProgress);
                        setSelectedAnimalGroup(null);
                        setCurrentStep(1);
                        setShowPromptSwitchToActionResetProgress(null);
                        resetRegistrationProgressForCurrAnimal();
                      }
                    }}
                  />
                )}

                {(selectedAction === 'buy' || selectedAction === 'sell') && selectedAnimalGroup === 'sheep' && (
                  <BuySellSheep
                    animalRowMode={animalRowMode}
                    profile={profile}
                    sheepAgeCategoryChoices={buySellSheepAgeCategoryKinds}
                    sheepAgeCategoryValues={buySellSheepAgeCategoryValues}
                    currentAnimalRow={currentAnimalRow}
                    selectedAction={selectedAction}
                    currentAnimalRowInputErrors={currentAnimalRowInputErrors}
                    onToggleComment={() => setAnimalRowShowAddComment((old) => !old)}
                    onChangeSheepKind={(selected) => {
                      onClickStep(3);
                      setCurrentAnimalRow((old) => ({ ...old, sheep_kind: selected }));
                    }}
                    onChangeSheepIndividualNo={(indNo) => {
                      setCurrentAnimalRow({
                        ...currentAnimalRow,
                        sheep_individual_no: indNo,
                      });
                    }}
                    onChangeSheepAmount={(amount) => {
                      setCurrentAnimalRow({
                        ...currentAnimalRow,
                        amount,
                      });
                    }}
                    onChangeSheepSubKind={(selected) => setCurrentAnimalRow((old) => ({
                      ...old,
                      sheep_race: selected,
                    }))}
                    editCommentForCurrAnimalRowProps={editCommentForCurrAnimalRowProps}
                    currAnimalRowIsValid={getCurrentAnimalRowIsValid()}
                    onSubmitOrEditClick={onAddEditAnimalRow}
                    onResetAnimalRow={resetAnimalRow}
                    currentAnimalRowErrorMsg={currentAnimalRowErrorMsg}
                  />
                )}

                {showRegularAddAnimalFlow() && (
                  <>
                    <div>
                      {(selectedAction === 'slaughter' || selectedAnimalGroup === 'pigs' || selectedAnimalGroup === 'cattle') && (
                        <StepWrapper
                          borderRadius="0.5em"
                          background="#F9F9F9"
                          padding="1.5em 2.5em"
                          marginTop="2em"
                          ref={(current) => {
                            scrollToMe('step3', current);
                          }}
                        >
                          <Row>
                            <Label size="2em" font="serif">
                              3.
                            </Label>
                            <StepHeader text={selectedAction === 'slaughter' || selectedAction === 'sell'
                              ? 'Henting '
                              : 'Mottak'}
                            />
                          </Row>

                          <Column align="center">
                            <Row marginTop="1em" marginLeft="-110px">
                              {(selectedAnimalGroup === 'cattle' && selectedAction === 'slaughter') && (
                                <div css="position: relative;">
                                  <Label inline>
                                    <Checkbox
                                      value={pickup_on_cattle_agrement}
                                      checked={pickup_on_cattle_agrement}
                                      onChange={(evt) => {
                                        const checked = evt.target.checked;
                                        setPickupOnCattleAgreement(checked);
                                      }}
                                      name="collect_on_cattle_agreement"
                                      label="Henting på storfe-avtale?"
                                    />
                                  </Label>

                                  <Helptext
                                    name="cattle-agreement"
                                    render={(text) => text && (
                                      <InfoBubble
                                        ariaLabel="Informasjon on feltet"
                                        popupStyle={{
                                          position: 'absolute',
                                          top: '26px',
                                          left: '-120px',
                                          minWidth: '12em',
                                        }}
                                        style={{
                                          position: 'absolute',
                                          marginLeft: '8px',
                                          marginTop: '-2px',
                                          fontSize: '1.2em',
                                        }}
                                      >
                                        <p
                                          style={{
                                            marginTop: '7px',
                                            marginBottom: '15px',
                                            fontSize: '0.9rem',
                                          }}
                                        >
                                          {text}
                                        </p>
                                      </InfoBubble>
                                    )}
                                  />
                                </div>
                              )}
                            </Row>

                            <Column marginTop="1em" align="center">
                              <WeekPicker
                                wanted_pickup_week={wanted_pickup_week}
                                wanted_pickup_year={wanted_pickup_year}
                                setWantedPickupWeek={setWantedPickupWeek}
                                setWantedPickupBasisYear={setWantedPickupBasisYear}
                                getIsWantedPickupBasisWeekValid={getIsWantedPickupBasisWeekValid}
                                getGoneOverDeadlineForDefaultWeek={getGoneOverDeadlineForDefaultWeek}
                                getInfoForSelectedPickupWeek={getInfoForSelectedPickupWeek}
                                isSelectedWeekAndYearValidForPickup={isSelectedWeekAndYearValidForPickup}
                                getPickupDateWording={getPickupDateWording}
                              />
                            </Column>
                          </Column>
                        </StepWrapper>
                      )}

                    </div>

                    {selectedAction === 'buy' && selectedAnimalGroup === 'cattle'
                      ? (
                        <BuyCattle
                          currentStep={Math.max(3, currentStep)}
                          currAnimalRowIsValid={getCurrentAnimalRowIsValid()}
                          refElemStartOfCustomEnrolmentFlow={refElemStartOfCustomEnrolmentFlow}
                          onSubmitOrEditClick={onAddEditAnimalRow}
                          animalRowMode={animalRowMode}
                          currentAnimalRowInputErrors={currentAnimalRowInputErrors}
                          hasEnteredDataInFirstStep={currentAnimalRow.live_animal_type}
                          onChangeAmount={(amount) => {
                            setCurrentAnimalRow({
                              ...currentAnimalRow,
                              amount,
                            });
                          }}
                          onChoosedOptionInStep={(value, step) => {
                            step.onChange(value);
                            setCurrentAnimalRowErrorMsg(null);
                          }}
                          onGetRefForStep={(ref, step) => scrollToMe(`buy_cattle_step_no${step.stepNo}`, ref)}
                          onGetRefForDetailsStep={(ref) => scrollToMe('buy_cattle_details', ref)}
                          setCurrentAnimalRow={setCurrentAnimalRow}
                          currentAnimalRow={currentAnimalRow}
                          resetAnimalRow={resetAnimalRow}
                          onToggleComment={() => setAnimalRowShowAddComment((old) => !old)}
                          setAnimalRowShowAddComment={setAnimalRowShowAddComment}
                          editCommentForCurrAnimalRowProps={editCommentForCurrAnimalRowProps}
                          currentAnimalRowErrorMsg={currentAnimalRowErrorMsg}
                          setCurrentStep={setCurrentStep}
                          onClickStep={onClickStep}
                        />
                      )
                      : (
                        <>
                          <div ref={refElemStartOfRegularEnrolmentFlow}>
                            <AddNewRowHeader>
                              {selectedAction === 'slaughter'
                                ? `${animalRowMode === 'add' ? 'Ny' : 'Endre'} innmeldingsrad`
                                : `${animalRowMode === 'add' ? 'Ny' : 'Endre'} rad for ${selectedAction === 'buy' ? 'kjøp' : 'salg'}`}
                            </AddNewRowHeader>
                          </div>

                          <StepWrapper
                            borderRadius="0.5em"
                            background="#F9F9F9"
                            padding="1.5em 2.5em"
                            marginTop="2em"
                          >
                            <Row>
                              <Label size="2em" font="serif">
                                {selectedAction === 'slaughter' || (selectedAnimalGroup === 'pigs' || selectedAnimalGroup === 'cattle')
                                  ? '4.'
                                  : '3.'}
                              </Label>
                              <StepHeader text="Velg dyr" />
                            </Row>

                            {selectedAnimalGroup === 'pigs' && (
                              <SlaughterBuySelllPigs
                                editCommentForCurrAnimalRowProps={editCommentForCurrAnimalRowProps}
                                selectedAction={selectedAction}
                                selectedAnimalSubGroup={selectedAnimalSubGroup}
                                isPigsWithIndividualRegistration={selectedAnimalSubGroup && isPigsWithIndividualRegistration()}
                                currentAnimalRowInputErrors={currentAnimalRowInputErrors}
                                currentAnimalRow={currentAnimalRow}
                                animalRowMode={animalRowMode}
                                onToggleComment={() => setAnimalRowShowAddComment((old) => !old)}
                                onChangePigKind={(selected) => {
                                  setSelectedAnimalSubGroup(selected);

                                  delete currentAnimalRow.individual_pigs;

                                  if ((selected.toLowerCase() === 'purke' || selected.toLowerCase() === 'råne') && getFeaturesEnabled().purke_raane_individual_registration) {
                                    if (currentAnimalRow.amount) {
                                      ontypingInvividualPigsAmount.current(currentAnimalRow.amount);
                                    }
                                  }
                                }}
                                onChangeReturnMeatAmount={(amount) => {
                                  setCurrentAnimalRow((old) => ({ ...old, return_meat: amount }));
                                }}
                                onChangeHealthRemarksAmount={(amount) => {
                                  setCurrentAnimalRow((old) => ({ ...old, health_remarks_cnt: amount }));
                                }}
                                onChangeReturnMeatCheckedIndividualPig={(checked, idxPig) => {
                                  setAtributeForIndividualPig({ key: 'return_meat', value: checked, idxPig });
                                }}
                                onChangeReturnMeatCheckedPigGroup={(checked) => {
                                  setCurrentAnimalRow((old) => ({
                                    ...old,
                                    return_meat_checked: checked,
                                    return_meat: null,
                                  }));
                                }}
                                onChangeHasHealthRemarksPigGroup={(checked) => {
                                  setCurrentAnimalRow((old) => ({
                                    ...old,
                                    has_health_remarks: checked,
                                  }));
                                }}
                                onChangeHasHealthRemarksIndividualPig={(checked, idxPig) => {
                                  setAtributeForIndividualPig({ key: 'has_health_remarks', value: checked, idxPig });
                                }}
                                onChangeAmount={(amount) => {
                                  if (isPigsWithIndividualRegistration()) {
                                    const num = Math.min(amount, 400);
                                    clearTimeout(ontypingInvividualPigsAmount.current);
                                    setTimeout(() => ontypingInvividualPigsAmount.current(num), 50);
                                  } else {
                                    setCurrentAnimalRow({
                                      ...currentAnimalRow,
                                      amount,
                                    });
                                  }
                                }}
                                onChangeEarTagIndividualPig={(ear_tag, idxPigToEdit) => {
                                  if (animalRowMode === 'add') {
                                    const individualPigs = [...currentAnimalRow.individual_pigs];
                                    individualPigs[idxPigToEdit].ear_tag = ear_tag;

                                    setCurrentAnimalRow({
                                      ...currentAnimalRow,
                                      individual_pigs: individualPigs,
                                    });
                                  } else {
                                    setCurrentAnimalRow({
                                      ...currentAnimalRow,
                                      ear_tag,
                                    });
                                  }
                                }}
                                onChangeClubNoPigGroup={(clubNo) => {
                                  setCurrentAnimalRow({
                                    ...currentAnimalRow,
                                    club_no: clubNo,
                                  });
                                }}
                              />
                            )}

                            {selectedAnimalGroup === 'sheep' && (
                              <SLaughterSheep
                                onChangeSheepKind={(selected) => {
                                  setSelectedAnimalSubGroup(selected);
                                }}
                                sheepKinds={sheepKinds}
                                selectedAnimalSubGroup={selectedAnimalSubGroup}
                                profile={profile}
                                currentAnimalRow={currentAnimalRow}
                                currentAnimalRowInputErrors={currentAnimalRowInputErrors}
                                currentRowReturnSheeep={getReturnSheep(currentAnimalRow)}
                                onToggleComment={() => setAnimalRowShowAddComment((old) => !old)}
                                editCommentForCurrAnimalRowProps={editCommentForCurrAnimalRowProps}
                                onChangeHasHealthRemarksSheep={(checked, idxForIndividualSheep) => {
                                  const curr = { ...currentAnimalRow };
                                  if (idxForIndividualSheep !== undefined) { // individual sheep
                                    if (!checked) {
                                      delete curr.return_sheep[idxForIndividualSheep].health_remarks_cnt;
                                    }
                                    curr.return_sheep[idxForIndividualSheep].has_health_remarks = checked;
                                  } else { // sheep group
                                    if (!checked) {
                                      delete curr.health_remarks_cnt;
                                    }
                                    curr.has_health_remarks = checked;
                                    setCurrentAnimalRow(curr);
                                  }
                                  setCurrentAnimalRow(curr);
                                }}
                                onCheckIsSheepCut={(isCut) => {
                                  setCurrentAnimalRow((old) => ({
                                    ...old,
                                    is_sheep_cut: isCut,
                                  }));
                                }}
                                onCheckHasReturnSkin={(checked, idxSheeep) => {
                                  const returnSheep = [
                                    ...currentAnimalRow.return_sheep,
                                  ];
                                  returnSheep[idxSheeep].return_skin = checked;
                                  setCurrentAnimalRow((old) => ({
                                    ...old,
                                    return_sheep: returnSheep,
                                  }));
                                }}
                                onCheckHasReturnMeat={(checked, idxSheep) => {
                                  const returnSheep = [
                                    ...currentAnimalRow.return_sheep,
                                  ];
                                  returnSheep[idxSheep].return_meat = checked;
                                  setCurrentAnimalRow((old) => ({
                                    ...old,
                                    return_sheep: returnSheep,
                                  }));
                                }}
                                onChangeReturnAnimalIndividualNo={(individualNo, idxSheep) => {
                                  // fixes a bug where updating the individual no of currentAnimalRow
                                  // also updates animalRows
                                  const returnSheep = JSON.parse(JSON.stringify([
                                    ...currentAnimalRow.return_sheep,
                                  ]));
                                  const target = { ...returnSheep[idxSheep] };
                                  target.individual_no = individualNo;
                                  returnSheep[idxSheep] = target;

                                  setCurrentAnimalRow((old) => ({
                                    ...old,
                                    return_sheep: returnSheep,
                                  }));
                                }}
                                onChangeReturnAnimalAmount={(amount) => {
                                  const num = Math.min(amount, 400);
                                  clearTimeout(onTypingSlaughterSheepReturnAmount.current);
                                  setTimeout(() => onTypingSlaughterSheepReturnAmount.current(num), 50);
                                }}
                                onChangeAmountSheep={(amount) => {
                                  setCurrentAnimalRow({
                                    ...currentAnimalRow,
                                    amount,
                                  });
                                }}
                                onChangeAmountReturnAnimals={(amount) => {
                                  const num = Math.min(amount, 400);
                                  clearTimeout(onTypingSlaughterSheepReturnAmount.current);
                                  setTimeout(() => onTypingSlaughterSheepReturnAmount.current(num), 50);
                                }}
                                onChangeHealthRemarksAmountSheep={(amount) => {
                                  setCurrentAnimalRow((old) => ({ ...old, health_remarks_cnt: amount }));
                                }}
                              />
                            )}
                            {selectedAnimalGroup === 'cattle' && (
                              <SlaughterSellCattle
                                animalRowMode={animalRowMode}
                                currentAnimalRow={currentAnimalRow}
                                selectedAction={selectedAction}
                                selectedAnimalSubGroup={selectedAnimalSubGroup}
                                indexAnimalRowToEdit={indexAnimalRowToEdit}
                                animalRows={animalRows}
                                animals={animals}
                                onChangeCattleKind={(selected) => {
                                  if (animalRowMode === 'add') {
                                    setSelectedAnimalSubGroup(selected);
                                    return;
                                  }
                                  setCurrentAnimalRow((old) => ({
                                    ...old,
                                    mark_no: null,
                                    individual_no: null,
                                  }));
                                  setSelectedAnimalSubGroup(selected);
                                }}
                                disabledCattleKindsValues={cattleKindsSell
                                  .map((e) => e.toLowerCase())
                                  .filter((k) => userHasAnimalKinds.indexOf(k) === -1)
                                  .concat(animals.animals.cattle.length === 0 ? ['all_kinds'] : [])}
                                cattleForDropdownForCurrFilters={selectedAnimalSubGroup && getCattleForSearchableDropdownBasedOnFilters()}
                                choosedCattleIDsFromDropdowIndexesByKind={choosedCattleIDsFromDropdowIndexesByKind}
                                onToggleShowOnlySelectedInDropdown={(newMode) => setOnlyShowSelectedCattleForDropdown(newMode === 'SELECTED')}
                                selectedMultipleItemsIdentifiers={selectedAnimalSubGroup && getChoosedCattleIdsFromDropdown(onlyShowSelectedCattleForDropdown)}
                                dropdownItemName={selectedAnimalSubGroup && getItemNameSelectedCattleKind()}
                                onCloseDropdown={() => {
                                  setOnlyShowSelectedCattleForDropdown(false);
                                  setSelectedAnimalSubGroup('all_kinds');
                                }}
                                onChoosedCattleInDropdown={(selected) => {
                                  if (animalRowMode === 'edit') {
                                    if (!selected) {
                                      return;
                                    }
                                    setCurrentAnimalRow((old) => ({
                                      ...old,
                                      mark_no: selected.mark_no,
                                      individual_no: selected.individual_no,
                                      subcategory_name: selected.subcategory_name,
                                    }));
                                  } else {
                                    onChoosedCattleIDSsFromDropdown(selected);
                                  }
                                }}
                                onDeleteCattle={(keyOrCattle) => {
                                  // delete cattle from current row data
                                  const copyOfCurrAnimalRow = { ...currentAnimalRow };
                                  delete copyOfCurrAnimalRow.cattle[keyOrCattle];
                                  setCurrentAnimalRow(copyOfCurrAnimalRow);

                                  // delete cattle from selected items in dropdown
                                  const cattleForDropdown = getCattleForSearchableDropdownBasedOnFilters();

                                  const identifiersSelected = cattleForDropdown
                                    .filter((c) => currentAnimalRow.cattle[getKeyForCattle(c)])
                                    .map((e) => e.uid);

                                  onChoosedCattleIDSsFromDropdown(identifiersSelected);
                                }}
                                onCheckReturnSkinMeat={(checked, cattleKey, dataKey) => {
                                  setAtributeForCattle({ value: checked, cattleKey, dataKey });
                                }}
                                onCheckHasHealthRemarks={(checked, cattleKey, dataKey) => {
                                  setAtributeForCattle({ value: checked, cattleKey, dataKey });
                                }}
                                onToggleComment={(keyOrCattle) => {
                                  if (animalRowMode === 'add') {
                                    updateCattleInRow({
                                      ...currentAnimalRow.cattle[keyOrCattle],
                                      showComment: !currentAnimalRow.cattle[keyOrCattle].showComment,
                                    },
                                    keyOrCattle);
                                  } else {
                                    setCurrentAnimalRow((old) => ({
                                      ...old,
                                      showComment: !currentAnimalRow.showComment,
                                    }));
                                  }
                                }}
                                onChangeComment={(comment, keyOrCattle) => {
                                  if (animalRowMode === 'add') {
                                    updateCattleInRow(
                                      {
                                        ...currentAnimalRow
                                          .cattle[keyOrCattle],
                                        comment,
                                      },
                                      keyOrCattle,
                                    );
                                  } else {
                                    setCurrentAnimalRow((old) => ({ ...old, comment }));
                                  }
                                }}
                                onCheckHorn={(checked, keyOrCattle) => {
                                  if (animalRowMode === 'add') {
                                    const currAnimalRowCopy = { ...currentAnimalRow };
                                    currAnimalRowCopy.cattle[
                                      keyOrCattle
                                    ] = {
                                      ...currentAnimalRow.cattle[keyOrCattle],
                                      horn: checked,
                                    };

                                    setCurrentAnimalRow(currAnimalRowCopy);
                                  } else {
                                    setCurrentAnimalRow((old) => ({
                                      ...old,
                                      horn: checked,
                                    }));
                                  }
                                }}
                                onSubmitChoosedCattleInDropdown={(items) => {
                                  if (!currentAnimalRow.cattle) {
                                    currentAnimalRow.cattle = {};
                                  }

                                  const copyOfCurrAnimalRow = {
                                    ...currentAnimalRow,
                                  };

                                  // replace cattles of this category with the selected, but keep
                                  // cattles of other categories
                                  copyOfCurrAnimalRow.cattle = {};
                                  const cattles = Object.values(copyOfCurrAnimalRow.cattle);
                                  const cattlesOfOtherCategories = cattles.filter((c) => !subcategoryEqualsIgnoreAgePart(c.split(';')[2], selectedAnimalSubGroup));

                                  for (const cattle of cattlesOfOtherCategories) {
                                    copyOfCurrAnimalRow[getKeyForCattle(cattle)] = cattle;
                                  }

                                  const selectedCattleOfAllKinds = flatArray(Object.values(choosedCattleIDsFromDropdowIndexesByKind));
                                  for (const cattleKey of selectedCattleOfAllKinds) {
                                    copyOfCurrAnimalRow.cattle[
                                      cattleKey
                                    ] = {
                                      ...currentAnimalRow.cattle[cattleKey],
                                      mark_no: cattleKey.split(';')[0],
                                      individual_no: cattleKey.split(';')[1],
                                      subcategory_name: cattleKey.split(';')[2],
                                    };
                                  }
                                  setCurrentAnimalRow(copyOfCurrAnimalRow);
                                }}
                                selectedCattleDropdownForEditMode={(() => {
                                  if ((!currentAnimalRow.mark_no && !currentAnimalRow.individual_no) || !selectedAnimalSubGroup) {
                                    return null;
                                  }
                                  const selected = getCattleForSearchableDropdownBasedOnFilters()
                                    .find((e) => e.mark_no === currentAnimalRow.mark_no && e.individual_no === currentAnimalRow.individual_no);
                                  return selected;
                                })()}
                                onCheckPregnant={(checked, keyOrCattle) => {
                                  if (animalRowMode === 'add') {
                                    const currAnimalRowCopy = { ...currentAnimalRow };
                                    currAnimalRowCopy.cattle[keyOrCattle] = {
                                      ...currentAnimalRow.cattle[keyOrCattle],
                                      pregnant: checked,
                                    };

                                    setCurrentAnimalRow(currAnimalRowCopy);
                                  } else {
                                    setCurrentAnimalRow(
                                      (old) => ({
                                        ...old,
                                        pregnant: checked,
                                      }),
                                    );
                                  }
                                }}
                              />
                            )}

                            {selectedAnimalSubGroup && (
                              <Column
                                width="100%"
                                marginTop="1.55em"
                                style={{ position: 'static' }}
                                marginBottom="0.6em"
                              >
                                <Button
                                  primaryCentered
                                  type="submit"
                                  disabled={!getCurrentAnimalRowIsValid()}
                                  onClick={() => onAddEditAnimalRow()}
                                >
                                  {animalRowMode === 'add' ? 'Legg til' : 'Endre'}
                                </Button>
                                <LinkLabel
                                  color="#c20000"
                                  onClick={resetAnimalRow}
                                  style={{
                                    textAlign: 'center',
                                    maxWidth: 'max-content',
                                    marginLeft: 'auto',
                                    marginRight: 'auto',
                                  }}
                                >
                                  {animalRowMode === 'add'
                                    ? 'Avbryt radinnleggelse'
                                    : 'Avbryt endring'}
                                </LinkLabel>
                                <Errors errors={currentAnimalRowErrorMsg} />
                              </Column>
                            )}
                          </StepWrapper>
                        </>
                      )}
                  </>
                )}

                {!!animalRows.length && (
                  <>
                    <Column
                      name="animalRowsAndAddNewPart"
                      borderRadius="0.5em"
                      background={getBrandingColor(colorTypes.whiteAltBg)}
                      padding="1.5em 2.5em"
                      style={{ overflowX: 'hidden' }}
                      marginTop="2em"
                    >
                      <Column align="center">
                        <Row
                          marginTop="0.4em"
                          marginBottom="1.8em"
                          alignSelf="center"
                        >
                          {(selectedAction === 'slaughter'
                            ? !selectedAnimalSubGroup
                            : Object.getOwnPropertyNames(currentAnimalRow).length === 0) && (
                              <Button
                                primary
                                onClick={selectFirstValidAnimalSubGroup}
                              >
                                <Cell padding="0.1em 0em">
                                  <Label bold size="1.2em">
                                    Legg til flere dyr
                                  </Label>
                                </Cell>
                              </Button>
                          )}
                        </Row>
                      </Column>

                      <AnimalRows
                        selectedAnimalGroup={selectedAnimalGroup}
                        selectedAnimalSubGroup={selectedAnimalSubGroup}
                        animalRows={animalRows}
                        animalRowShowCommentForRowNo={animalRowShowCommentForRowNo}
                        onToggleComment={(index) => {
                          if (animalRowShowCommentForRowNo === -1) {
                            setAnimalRowShowCommentForRowNo(index);
                          }
                        }}
                        onCloseComment={() => {
                          setAnimalRowShowCommentForRowNo(-1);
                        }}
                        onCLickEditRow={(index) => {
                          onEditAnimalRow(getIndexByReverseIndex(index));
                        }}
                        onDeleteAnimalRow={(idx) => onDeleteAnimalRow(idx)}
                        onCancelDelete={() => {
                          setIndexAnimalRowToShowDeleteConfirmation(-1);
                        }}
                        onConfirmDelete={() => {
                          const rowToDeleteIndex = indexAnimalRowToShowDeleteConfirmation;
                          // hide modal
                          setIndexAnimalRowToShowDeleteConfirmation(-1);

                          // give the modal some time to close before continuing so that remove animation is visible
                          setTimeout(() => {
                            // hide the row visually - this animates the dissaperance of the row
                            // and ensures that the animation is performed on the correct row
                            const animalRowsCopy = [...animalRows];
                            animalRowsCopy[indexAnimalRowToShowDeleteConfirmation].hidden = true;

                            setAnimalRows(animalRowsCopy);

                            setTimeout(() => {
                              // delete the row from the row data, but after the delete animation is finished
                              deleteAnimalRow(rowToDeleteIndex);
                            }, 500);
                          }, 200);
                        }}
                        indexAnimalRowToShowDeleteConfirmation={indexAnimalRowToShowDeleteConfirmation}
                        selectedAction={selectedAction}
                      />
                    </Column>

                    <AfterStepsItems>
                      {(selectedAction === 'slaughter' || selectedAnimalGroup === 'pigs' || selectedAnimalGroup === 'cattle') && (
                        <Label marginBottom="1.1em">
                          <span style={{ fontWeight: 'bold' }}>
                            {getPickupDateWording()}
                            :
                          </span>
                          {' Uke '}
                          {wanted_pickup_week}
                          {' '}
                          {wanted_pickup_year !== getCurrentYear()
                            ? `(${wanted_pickup_year})`
                            : ''}
                          {' '}
                        </Label>
                      )}
                      <div>
                        <AddCommentToggleButton
                          customTxt="Legg til kommentar for hele innmeldingen"
                          centerComment
                          style={{ paddingBottom: '1em' }}
                          onToggleComment={() => setShowComment((old) => !old)}
                        />
                        <EditComment
                          showComment={showComment}
                          maxLength={maxCharactersCommentWhole}
                          comment={comment}
                          onChangeComment={(comment) => setComment(comment)}
                        />
                      </div>
                    </AfterStepsItems>

                    {shouldShowReturnMeatPickupLocationEdit && (
                      <RegisterStep
                        name="step_1"
                        stepNo={5}
                        stepHeader="Velg hentested for returkjøtt"
                        stepSubheader="Må fylles ut"
                      >
                        <SpecifyReturnMeatPickupLocation
                          comment={return_meat_pickup_location}
                          onChangeComment={(comment) => set_return_meat_pickup_location(comment)}
                        />
                      </RegisterStep>
                    )}

                    {shouldShowReturnFormMeat && (
                      <StepWrapper
                        borderRadius="0.5em"
                        background="#F9F9F9"
                        padding="1.5em 2.5em"
                        marginTop="-1em"
                        marginBottom={!shouldShowReturnFormSkin ? '1em' : '0'}
                        className="return-form-step-wrapper"
                      >
                        <Row>
                          <Label size="2em" font="serif">
                            5.
                          </Label>
                          <Label
                            bold
                            align="flex-end"
                            size="1em"
                            marginLeft="1em"
                            marginBottom="0.3em"
                          >
                            Returkjøtt
                          </Label>
                        </Row>

                        <ReturnForm
                          animalKind={selectedAnimalGroup}
                          animalRows={getAnimalRowsWithReturn('return_meat', animalRows)}
                          form={returnSlaughterOptionsForm}
                          groupsData={returnSlaughterOptionsGroups}
                          description={returnSlaughterOptionsForm?.data?.description_meat}
                          commonData={returnSlaughterOptionsCommon}
                          onDeleteGroup={deleteReturnSlaughterOptionsGroup}
                          onMoveAnimalsToGroup={moveAnimalsToReturnSlaughterOptionsGroup}
                          onChangeGroupComment={changeCommentForReturnSlaughterOptionsMeat}
                          comment={returnSlaughterOptionsCommentMeat}
                          onChangeFormValue={updateFormValueInReturnsSlaughterOptions}
                          commonFieldsKinds={['meat']}
                        />
                      </StepWrapper>
                    )}

                    {shouldShowReturnFormSkin && (
                      <StepWrapper
                        borderRadius="0.5em"
                        background="#F9F9F9"
                        padding="1.5em 2.5em"
                        marginTop={enrolmentHasAnimalsWithReturnMeat ? '2em' : '-1em'}
                        marginBottom="1em"
                        className="return-form-step-wrapper"
                      >
                        <Row>
                          <Label size="2em" font="serif">
                            6.
                          </Label>
                          <Label
                            bold
                            align="flex-end"
                            size="1em"
                            marginLeft="1em"
                            marginBottom="0.3em"
                          >
                            Returhud og returskinn
                          </Label>
                        </Row>

                        <ReturnForm
                          animalKind={selectedAnimalGroup}
                          animalRows={getAnimalRowsWithReturn('return_skin', animalRows)}
                          form={returnSlaughterOptionsForm}
                          groupsData={[]}
                          disableGrouping
                          commonData={returnSlaughterOptionsCommon}
                          description={returnSlaughterOptionsForm?.data?.description_skin}
                          onDeleteGroup={deleteReturnSlaughterOptionsGroup}
                          onMoveAnimalsToGroup={moveAnimalsToReturnSlaughterOptionsGroup}
                          onChangeGroupComment={changeCommentForReturnSlaughterOptionsSkin}
                          comment={returnSlaughterOptionsCommentSkin}
                          onChangeFormValue={updateFormValueInReturnsSlaughterOptions}
                          commonFieldsKinds={['skin']}
                        />
                      </StepWrapper>
                    )}

                    {getAnimalRowsHasOneOrMoreHealthRemarks() && (
                      <RegisterStep
                        name="step_1"
                        stepNo={[5, 6, 7][(shouldShowReturnMeatPickupLocationEdit ? 1 : 0) + (shouldShowReturnFormMeat ? 1 : 0) + (shouldShowReturnFormSkin ? 1 : 0)]}
                        stepHeader="Fyll ut informasjon om dyr med helseavvik"
                      >
                        <SpecifyHealthRemarks
                          animalRows={animalRows}
                          selectedAnimalGroup={selectedAnimalGroup}
                          onChangeAmountAnimalsInGroup={({ amount, animalRowIdx, healthRemarkGroupIdx }) => {
                            const cpy = [...animalRows];
                            cpy[animalRowIdx].health_remarks_groups[healthRemarkGroupIdx].amount_animals = amount;
                            setAnimalRows(cpy);
                          }}
                          onChangeHealthRemark={({
                            remark, animalRowIdx, healthRemarkGroupIdx, isIndividual, isReturnSheep, returnSheepIdx,
                          }) => {
                            const cpy = [...animalRows];
                            if (isIndividual) {
                              if (isReturnSheep) {
                                cpy[animalRowIdx].return_sheep[returnSheepIdx].health_remarks_code = remark.id;
                              } else {
                                cpy[animalRowIdx].health_remarks_code = remark.id;
                              }
                            } else {
                              cpy[animalRowIdx].health_remarks_groups[healthRemarkGroupIdx].health_remarks_code = remark.id;
                            }
                            setAnimalRows(cpy);
                          }}
                          onChangeComment={({
                            comment, animalRowIdx, healthRemarkGroupIdx, isIndividual, isReturnSheep, returnSheepIdx,
                          }) => {
                            const cpy = [...animalRows];

                            if (isIndividual) {
                              if (isReturnSheep) {
                                cpy[animalRowIdx].return_sheep[returnSheepIdx].health_remarks_comment = comment;
                              } else {
                                cpy[animalRowIdx].health_remarks_comment = comment;
                              }
                            } else {
                              cpy[animalRowIdx].health_remarks_groups[healthRemarkGroupIdx].health_remarks_comment = comment;
                            }
                            setAnimalRows(cpy);
                          }}
                          onAddHealthRemarksGroup={(animalRowIdx) => {
                            const cpy = [...animalRows];
                            if (!cpy[animalRowIdx].health_remarks_groups) {
                              cpy[animalRowIdx].health_remarks_groups = [];
                            }
                            cpy[animalRowIdx].health_remarks_groups.push({});
                            setAnimalRows(cpy);
                          }}
                          onDeleteHealthRemarkGroup={(animalRowIdx, groupIdx) => {
                            const cpy = [...animalRows];
                            cpy[animalRowIdx].health_remarks_groups.splice(groupIdx, 1);
                            setAnimalRows(cpy);
                          }}
                        />
                      </RegisterStep>
                    ) }

                    <AfterStepsItems>
                      {getFeaturesEnabled().show_medication_holdback_info_on_enrolmentpage && getHasMedicationsWithRestrainWithinWeek() && (
                        <>
                          <Helptext
                            name="medication_holdback_detected_info"
                            render={(html) => (
                              <MedicationWithHoldbackWithinWeekInfo>
                                <HTML>
                                  {html}
                                </HTML>
                              </MedicationWithHoldbackWithinWeekInfo>
                            )}
                          />
                        </>
                      )}

                      {getFeaturesEnabled().show_medication_holdback_info_on_enrolmentpage && (getHasMedicationsWithRestrainWithinWeek() || getAnimalRowsHasOneOrMoreReturn({ returnMeatOnly: true })) && (
                        <InfoBox>
                          <ErrorContHeader className="box-header">Skjemaer</ErrorContHeader>
                          {(getHasMedicationsWithRestrainWithinWeek()) && (
                            <Helptext
                              name="medication_holdback_form_info"
                              render={(html) => (
                                <HTML>
                                  {html}
                                </HTML>
                              )}
                            />
                          )}

                          {(getAnimalRowsHasOneOrMoreReturn({ returnMeatOnly: true })) && (
                            <Helptext
                              name="return_meat_skin_form_info"
                              render={(html) => (
                                <HTML>
                                  {html}
                                </HTML>
                              )}
                            />
                          )}
                        </InfoBox>
                      )}

                      {saveEnrolment.response
                        && nonEmptyArray(saveEnrolment.response.animal_remarks)
                        && saveEnrolment.response.animal_remarks.some((a) => nonEmptyArray(a.medications_restrain_limit_after_week))
                        && (
                          <div>
                            <ErrorCont
                              style={{
                                fontSize: '1.1em',
                                padding: '1em',
                              }}
                            >
                              <ErrorContHeader>
                                Medisin/Sykdom
                              </ErrorContHeader>
                              Det er oppdaget sykdommer og/eller medisiner på
                              et eller flere av de valgte dyrene. Vennligst
                              fjern dyr med medisiner og/eller sykdommer og
                              prøv igjen.
                              {saveEnrolment.response.animal_remarks
                                .filter((a) => nonEmptyArray(a.medications_restrain_limit_after_week))
                                .map((a) => (
                                  <div style={{ marginBottom: '2em' }}>
                                    <Label size="1em" bold>
                                      Dyr:
                                      {' '}
                                      {a.animal_id}
                                    </Label>

                                    <div style={{ paddingLeft: '3em' }}>
                                      {a.medications_restrain_limit_after_week && (
                                        <div>
                                          <Label size="1.1em">
                                            Medisiner
                                          </Label>
                                          {a.medications_restrain_limit_after_week.map((m) => (
                                            <MedicationInfo med={m} />
                                          ))}
                                        </div>
                                      )}

                                      {a.diseases && (
                                        <div>
                                          <Label size="1.1em">
                                            Sykdommer
                                          </Label>
                                          <DiseasesList diseases={a.diseases} />
                                        </div>
                                      )}
                                    </div>
                                  </div>
                                ))}
                            </ErrorCont>
                          </div>
                        )}
                      {saveEnrolment.response
                        && nonEmptyArray(saveEnrolment.response.animal_remarks)
                        && saveEnrolment.response.animal_remarks.some((a) => nonEmptyArray(a.medications_restrain_limit_within_week))
                        && (
                          <div>
                            <ErrorCont
                              style={{
                                fontSize: '1.1em',
                                marginBottom: '2em',
                                padding: '1em',
                              }}
                            >
                              <ErrorContHeader>
                                Medisin med utløp innenfor henteuke
                              </ErrorContHeader>
                              Det er oppdaget et eller flere dyr med
                              tilbakeholdelsefrist samme uke som ønsket
                              innmeldingsuke. Vennligst bekreft at disse
                              dyrene du leverer til slakt vil være fri for
                              medisin innen dyrene hentes.
                              {saveEnrolment.response.animal_remarks
                                .filter((a) => nonEmptyArray(
                                  a.medications_restrain_limit_within_week,
                                ))
                                .map((a) => (
                                  <div style={{ marginBottom: '2em' }}>
                                    <Label size="1em" bold>
                                      Dyr:
                                      {' '}
                                      {a.animal_id}
                                    </Label>

                                    <div style={{ paddingLeft: '3em' }}>
                                      {a.medications_restrain_limit_within_week && (
                                        <div>
                                          <Label size="1.1em">
                                            Medisiner
                                          </Label>
                                          {a.medications_restrain_limit_within_week.map((m) => (
                                            <MedicationInfo med={m} />
                                          ))}
                                        </div>
                                      )}
                                    </div>
                                  </div>
                                ))}
                              <Checkbox
                                big
                                checked={confirm_choosen_animal_medications_restrain_limit_within_week}
                                name="confirm_choosed_animal_medication_within_week"
                                onChange={(evt) => {
                                  const checked = evt.target.checked;
                                  setConfirm_choosen_animal_medications_restrain_limit_within_week(
                                    checked,
                                  );
                                }}
                                label={(
                                  <div>
                                    &laquo;Jeg bekrefter at dyrene jeg
                                    <br />
                                    melder inn er fri for medisin innen dyrene
                                    hentes&raquo;
                                  </div>
                                )}
                              />
                            </ErrorCont>
                          </div>
                        )}

                      {saveEnrolment.response
                        && nonEmptyArray(saveEnrolment.response.animals_maybe_in_group_remarks)
                        && saveEnrolment.response.animals_maybe_in_group_remarks.some((a) => nonEmptyArray(a.medications_restrain_limit_after_week))
                        && (
                          <div>
                            <ErrorCont
                              style={{
                                fontSize: '1.1em',
                                marginBottom: '2em',
                                padding: '1em',
                              }}
                            >
                              <ErrorContHeader>
                                Medisin/Sykdom
                              </ErrorContHeader>
                              Det er oppdaget individuelle
                              {' '}
                              {animalKindToNorwegian(selectedAnimalGroup).toLowerCase()}
                              {' '}
                              med tilbakeholdsfrist som følge av sykdommene
                              nedenfor. Vennligst bekreft at dyrene du melder
                              inn ikke er blant disse.
                              {saveEnrolment.response.animals_maybe_in_group_remarks
                                .filter((a) => nonEmptyArray(a.medications_restrain_limit_after_week))
                                .map((a) => (
                                  <div style={{ marginBottom: '2em' }}>
                                    <Label size="1em" bold>
                                      Dyr:
                                      {' '}
                                      {a.animal_id}
                                    </Label>

                                    <div style={{ paddingLeft: '3em' }}>
                                      {a.medications_restrain_limit_after_week && (
                                        <div>
                                          <Label size="1.1em">
                                            Medisiner
                                          </Label>
                                          {a.medications_restrain_limit_after_week.map((m) => (
                                            <MedicationInfo med={m} />
                                          ))}
                                        </div>
                                      )}

                                      {a.diseases && (
                                        <div>
                                          <Label size="1.1em">
                                            Sykdommer
                                          </Label>
                                          <DiseasesList diseases={a.diseases} />
                                        </div>
                                      )}
                                    </div>
                                  </div>
                                ))}
                              <Checkbox
                                name="confirm_animals_not_in_crowd"
                                big
                                checked={confirm_animals_not_in_crowd}
                                onChange={(evt) => {
                                  const checked = evt.target.checked;
                                  setConfirmAnimalsNotInCrowd(checked);
                                }}
                                label={(
                                  <div>
                                    &laquo;Jeg bekrefter at dyrene jeg
                                    <br />
                                    melder inn til slakt er fri for medisin
                                    innen dyrene hentes&raquo;
                                  </div>
                                )}
                              />
                            </ErrorCont>
                          </div>
                        )}

                      {saveEnrolment.response
                        && nonEmptyArray(saveEnrolment.response.animals_maybe_in_group_remarks)
                        && saveEnrolment.response.animals_maybe_in_group_remarks.some((a) => nonEmptyArray(a.medications_restrain_limit_within_week))
                        && (
                          <div>
                            <ErrorCont
                              style={{
                                marginBottom: '2em',
                                padding: '1em',
                              }}
                            >
                              <ErrorContHeader>
                                Medisin med utløp innenfor henteuke
                              </ErrorContHeader>
                              Det er oppdaget individuelle
                              {' '}
                              {animalKindToNorwegian(selectedAnimalGroup).toLowerCase()}
                              {' '}
                              med tilbakeholdelsefrist samme uke som ønsket
                              innmeldingsuke. Vennligst bekreft at disse
                              dyrene du leverer til slakt ikke er blant disse
                              dyrene.
                              {saveEnrolment.response.animals_maybe_in_group_remarks
                                .filter((a) => nonEmptyArray(a.medications_restrain_limit_within_week))
                                .map((a) => (
                                  <div style={{ marginBottom: '2em' }}>
                                    <Label size="1em" bold>
                                      Dyr:
                                      {' '}
                                      {a.animal_id}
                                    </Label>

                                    <div style={{ paddingLeft: '3em' }}>
                                      {a.medications_restrain_limit_within_week && (
                                        <div>
                                          <Label size="1.1em">
                                            Medisiner
                                          </Label>
                                          {a.medications_restrain_limit_within_week.map(
                                            (m) => (
                                              <MedicationInfo med={m} />
                                            ),
                                          )}
                                        </div>
                                      )}
                                    </div>
                                  </div>
                                ))}
                              <Checkbox
                                name="confirm_animals_not_in_crowd_within_week"
                                big
                                checked={confirm_animals_not_in_crowd_within_week}
                                onChange={(evt) => {
                                  const checked = evt.target.checked;
                                  setConfirmAnimalsNotInCrowdWithinWeek(checked);
                                }}
                                label={(
                                  <div>
                                    &laquo;Jeg bekrefter at dyrene jeg
                                    <br />
                                    melder inn til slakt er fri for medisin
                                    innen dyrene hentes&raquo;
                                  </div>
                                )}
                              />
                            </ErrorCont>
                          </div>
                        )}

                      {/*------*/}
                      {saveEnrolment.response
                        && nonEmptyArray(saveEnrolment.response.animals_with_textual_animal_ids)
                        && saveEnrolment.response.animals_with_textual_animal_ids.some((e) => nonEmptyArray(e.medications_restrain_limit_after_week))
                        && (
                          <div>
                            <ErrorCont
                              style={{
                                fontSize: '1.1em',
                                marginBottom: '2em',
                                padding: '1em',
                              }}
                            >
                              <ErrorContHeader>
                                Medisin/Sykdom
                              </ErrorContHeader>
                              Det er oppdaget
                              {' '}
                              {animalKindToNorwegian(selectedAnimalGroup).toLowerCase()}
                              {' '}
                              med ikke-numeriske dyreID-er (antakeligvis
                              grupper med dyr), med tilbakeholdsfrist som
                              følge av sykdommene nedenfor. Vennligst bekreft
                              at dyrene du melder inn ikke er blant disse.
                              {saveEnrolment.response.animals_with_textual_animal_ids
                                .filter((a) => nonEmptyArray(a.medications_restrain_limit_after_week))
                                .map((a) => (
                                  <div style={{ marginBottom: '2em' }}>
                                    <Label size="1em" bold>
                                      DyreID:
                                      {' '}
                                      {a.animal_id}
                                    </Label>

                                    <div style={{ paddingLeft: '3em' }}>
                                      {a.medications_restrain_limit_after_week && (
                                        <div>
                                          <Label size="1.1em">
                                            Medisiner
                                          </Label>
                                          {a.medications_restrain_limit_after_week.map(
                                            (m) => (
                                              <MedicationInfo med={m} />
                                            ),
                                          )}
                                        </div>
                                      )}

                                      {a.diseases && (
                                        <div>
                                          <Label size="1.1em">
                                            Sykdommer
                                          </Label>
                                          <DiseasesList diseases={a.diseases} />
                                        </div>
                                      )}
                                    </div>
                                  </div>
                                ))}
                              <Checkbox
                                name="confirm_textual_animal_ids_medication_ok"
                                big
                                checked={confirm_textual_animal_ids_medication_ok}
                                onChange={(evt) => {
                                  const checked = evt.target.checked;
                                  setConfirm_textual_animal_ids_medication_ok(checked);
                                }}
                                label={(
                                  <div>
                                    &laquo;Jeg bekrefter at dyrene jeg
                                    <br />
                                    melder inn til slakt er fri for medisin
                                    innen dyrene hentes&raquo;
                                  </div>
                                )}
                              />
                            </ErrorCont>
                          </div>
                        )}

                      {saveEnrolment.response
                        && nonEmptyArray(saveEnrolment.response.animals_with_textual_animal_ids)
                        && saveEnrolment.response.animals_with_textual_animal_ids.some((e) => nonEmptyArray(e.medications_restrain_limit_within_week))
                        && (
                          <div>
                            <ErrorCont
                              style={{
                                marginBottom: '2em',
                                padding: '1em',
                              }}
                            >
                              <ErrorContHeader>
                                Medisin med utløp innenfor henteuke
                              </ErrorContHeader>
                              Det er oppdaget
                              {' '}
                              {animalKindToNorwegian(selectedAnimalGroup).toLowerCase()}
                              {' '}
                              med ikke-numeriske dyreID-er(antakeligvis
                              grupper med dyr), med tilbakeholdsfrist som
                              følge av sykdommene nedenfor. Vennligst bekreft
                              at dyrene du melder inn ikke er blant disse
                              dyrene.
                              {saveEnrolment.response.animals_with_textual_animal_ids
                                .filter((a) => nonEmptyArray(a.medications_restrain_limit_within_week))
                                .map((a) => (
                                  <div style={{ marginBottom: '2em' }}>
                                    <Label size="1em" bold>
                                      DyreID:
                                      {' '}
                                      {a.animal_id}
                                    </Label>

                                    <div style={{ paddingLeft: '3em' }}>
                                      {a.medications_restrain_limit_within_week && (
                                        <div>
                                          <Label size="1.1em">
                                            Medisiner
                                          </Label>
                                          {a.medications_restrain_limit_within_week.map(
                                            (m) => (
                                              <MedicationInfo med={m} />
                                            ),
                                          )}
                                        </div>
                                      )}
                                      {a.diseases && (
                                        <div>
                                          <Label size="1.1em">
                                            Sykdommer
                                          </Label>
                                          <DiseasesList diseases={a.diseases} />
                                        </div>
                                      )}
                                    </div>
                                  </div>
                                ))}
                              <Checkbox
                                name="confirm_textual_animal_ids_within_week_ok"
                                big
                                checked={confirm_textual_animal_ids_within_week_ok}
                                onChange={(evt) => {
                                  const checked = evt.target.checked;
                                  setConfirm_textual_animal_ids_within_week_ok(checked);
                                }}
                                label={(
                                  <div>
                                    &laquo;Jeg bekrefter at dyrene jeg
                                    <br />
                                    melder inn til slakt er fri for medisin
                                    innen dyrene hentes&raquo;
                                  </div>
                                )}
                              />
                            </ErrorCont>
                          </div>
                        )}

                      {saveEnrolment.response
                        && saveEnrolment.response.group_remarks
                        && saveEnrolment.response.group_remarks.group_medications_restrain_limit_after_week
                        && (
                          <div>
                            <ErrorCont
                              style={{
                                fontSize: '1.1em',
                                padding: '1em',
                              }}
                            >
                              <ErrorContHeader>
                                Medisin/sykdom på valgt gruppe
                              </ErrorContHeader>
                              Det er oppdaget en flokk med
                              tilbakeholdelsefrist som følge av sykdommene
                              nedenfor. Vennligst bekreft at disse dyrene du
                              leverer til slakt er fri for medisin.
                              <Label size="1em" bold>
                                Gruppe:
                                {' '}
                                {animalKindToNorwegian(saveEnrolment.response.group_remarks.group_category)}
                              </Label>
                              <div style={{ paddingLeft: '3em' }}>
                                {saveEnrolment.response.group_remarks.group_medications_restrain_limit_after_week && (
                                  <div>
                                    <Label size="1.2em">Medisiner</Label>
                                    {saveEnrolment.response.group_remarks.group_medications_restrain_limit_after_week.map((m) => (
                                      <MedicationInfo med={m} />
                                    ))}
                                  </div>
                                )}

                                {saveEnrolment.response.group_remarks.group_diseases && (
                                  <div>
                                    <Label size="1.2em">Sykdommer</Label>
                                    {saveEnrolment.response.group_remarks.group_diseases.map((m) => (
                                      <div
                                        style={{
                                          display: 'flex',
                                          flexDirection: 'row',
                                          marginLeft: '1.5em',
                                        }}
                                      >
                                        <Label marginLeft="1em">
                                          Navn:
                                          {' '}
                                          {m.name}
                                        </Label>
                                        <Label marginLeft="1em">
                                          Kode:
                                          {' '}
                                          {m.code}
                                        </Label>
                                      </div>
                                    ))}
                                  </div>
                                )}
                              </div>
                              <Checkbox
                                name="confirmbug_group_has_no_diseases_sickness"
                                big
                                checked={confirm_group_disease_medication_after_week}
                                onChange={(evt) => {
                                  const checked = evt.target.checked;
                                  setConfirmGroupDiseaseMedicationAfterWeek(checked);
                                }}
                                label={(
                                  <div>
                                    &laquo;Jeg bekrefter at dyrene jeg
                                    <br />
                                    melder inn til slakt er fri for
                                    medisin&raquo;
                                  </div>
                                )}
                              />
                            </ErrorCont>
                          </div>
                        )}
                      {saveEnrolment.response
                        && saveEnrolment.response.group_remarks
                        && saveEnrolment.response.group_remarks.group_medications_restrain_limit_within_week
                        && (
                          <div>
                            <div>
                              <ErrorCont
                                style={{
                                  fontSize: '1.1em',
                                  padding: '1em',
                                  color: '#4a4a4a',
                                }}
                              >
                                <ErrorContHeader>
                                  Medisin med utløp innenfor henteuke på valgt
                                  gruppe
                                </ErrorContHeader>
                                Det er oppdaget en flokk med
                                tilbakeholdelsefrist samme uke som ønsket
                                innmeldingsuke. Vennligst bekreft at disse
                                dyrene du leverer til slakt vil være fri for
                                medisin innen dyrene hentes.
                                <Label size="1em" bold>
                                  Gruppe:
                                  {' '}
                                  {animalKindToNorwegian(
                                    saveEnrolment.response.group_remarks
                                      .group_category,
                                  )}
                                </Label>
                                <div style={{ paddingLeft: '3em' }}>
                                  {saveEnrolment.response.group_remarks
                                    .group_medications_restrain_limit_within_week && (
                                      <div>
                                        <Label size="1.2em">Medisiner</Label>
                                        {saveEnrolment.response.group_remarks.group_medications_restrain_limit_within_week.map((m) => (
                                          <MedicationInfo med={m} />
                                        ))}
                                      </div>
                                  )}
                                </div>
                                <Checkbox
                                  name="confirmbug_group_has_no_diseases_sickness_same_week"
                                  big
                                  checked={confirm_group_medications_restrain_limit_within_week}
                                  onChange={(evt) => {
                                    const checked = evt.target.checked;
                                    setConfirm_group_medications_restrain_limit_within_week(checked);
                                  }}
                                  label={(
                                    <div>
                                      &laquo;Jeg bekrefter at dyrene jeg
                                      <br />
                                      melder inn til slakt er fri for medisin
                                      innen dyrene hentes.&raquo;
                                    </div>
                                  )}
                                />
                              </ErrorCont>
                            </div>
                          </div>
                        )}

                      <Column marginTop="4em">
                        {selectedAction !== 'buy' && (
                          <div>
                            <Checkbox
                              big
                              checked={agreesAnimalsFitForTransport}
                              name="agrees_animals_fit_for_transport"
                              maxWidthLabel="91%"
                              onChange={(evt) => {
                                const checked = evt.target.checked;
                                setAgreesAnimalsFitForTransport(checked);
                              }}
                              label={<Helptext name="submit-agreement" />}
                            />
                            {getFeaturesEnabled().extraCheckboxConfirmRegisterSlaughter && selectedAction === 'slaughter' && (
                              <Checkbox
                                big
                                checked={agreesExtra}
                                name="agrees_animals_medication"
                                maxWidthLabel="91%"
                                onChange={(evt) => {
                                  const checked = evt.target.checked;
                                  setAgreesExtra(checked);
                                }}
                                label={<Helptext name="submit-agreement-2" />}
                              />
                            )}
                          </div>
                        )}
                        {(selectedAnimalGroup === 'cattle' || selectedAnimalGroup === 'sheep')
                          && selectedAction === 'slaughter'
                          && enrolmentHasAnimalsWithReturnMeat && getFeaturesEnabled().enrolmentWantReturnMarksCheckbox
                          && (
                            <Label
                              inline
                              style={{ position: 'relative' }}
                              marginTop="1.2em"
                            >
                              <div
                                style={{
                                  float: 'left',
                                  prosition: 'relative',
                                }}
                              >
                                <Checkbox
                                  big
                                  checked={wantMarksSentOnReturn}
                                  name="wants_marks_on_return"
                                  onChange={(evt) => {
                                    const checked = evt.target.checked;
                                    setWantMarksSentOnReturn(checked);
                                  }}
                                  label="
                                      Ønsker tilsendt merker for retur
                                    "
                                />
                              </div>
                              <InfoBubble
                                aira-label="Informasjon om å få tilsendt merker for retur"
                                style={{
                                  marginTop: '0.2em',
                                  marginLeft: '0.3em',
                                }}
                                popupStyle={{
                                  top: '31px',
                                  right: '-10em',
                                  left: '-190px',
                                  width: '14em',
                                  position: 'absolute',
                                }}
                              >
                                <p style={{ fontSize: '0.9rem' }}>
                                  <Helptext
                                    name="send-marks-on-return-description"
                                  />
                                  {getBrandingLinks(linkTypes.marksOnReturnInfo) && (
                                    <>
                                      Du kan lese mere om dette på:
                                      <a
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        style={{ marginLeft: '0.5em' }}
                                        href={getBrandingLinks(linkTypes.marksOnReturnInfo)}
                                      >
                                        {getBrandingLinks(linkTypes.marksOnReturnInfo)}
                                      </a>
                                    </>
                                  )}
                                </p>
                              </InfoBubble>
                            </Label>
                          )}

                        {getFeaturesEnabled().return_info && selectedAction === 'slaughter' && getAnimalRowsHasOneOrMoreReturn() && (
                          <div css={css`margin-top: 2em; a{color: ${getBrandingColor('linkPrimary')}}`}>
                            <Button
                              backgroundColor="#efefef"
                              fullwidth
                              onClick={() => setShowReturnAnimalInfo((old) => !old)}
                            >
                              Viktig informasjon om retur
                              <FontAwesomeIcon icon={showReturnAnimalInfo ? faArrowUp : faArrowDown} css={css`margin-left: 1em;`} />
                            </Button>
                            <motion.div
                              animate={showReturnAnimalInfo ? 'visible' : 'collapsed'}
                              initial="collapsed"
                              variants={expandCollapseVariants}
                              css={css`
                                max-width: 80vw;
                                margin-left: auto;
                                margin-right: auto;
                              `}
                            >
                              <Helptext
                                name="return_animals_info"
                                render={(html) => html && <HTML>{html}</HTML>}
                              />
                            </motion.div>
                          </div>
                        )}
                      </Column>

                      {!getRegistrationReadyForSending() && (
                        <div style={{ marginTop: '2.5em' }}>
                          <Label style={{ fontStyle: 'italic' }}>Før du kan melde inn må:</Label>
                          <ul style={{ fontStyle: 'italic', marginBottom: '0', marginTop: '0' }}>
                            <li>Ønsket henteuke være gyldig</li>
                            <li>
                              Kommentarer i kommentar-boksene ikke være lengere enn grensen for hver boks
                            </li>
                            <li>
                              {getFeaturesEnabled().extraCheckboxConfirmRegisterSlaughter ? 'Bekfreftingsboksene' : 'Bekfreftingsboksen'}
                              {company === 'furuseth' ? ' om sykdommer og avvik' : ''}
                              {' '}
                              ovenfor være huket av
                            </li>
                            <li>
                              Dyr eller grupper med medisiner med tilbakeholdsfrist være
                              fjernet eller bekreftet
                            </li>
                            <li>Dyr eller grupper med helseavvik være lagt inn og oppfylle kravene ovenfor</li>
                            {shouldShowReturnFormMeat && enrolmentHasAnimalsWithReturnMeat
                                    && <li>Alle dyr for returslakt være fordelt på en eller flere oppdeling-grupper</li>}
                            {shouldShowReturnMeatPickupLocationEdit
                                    && <li>Hentested for returkjøtt være lagt inn</li>}
                          </ul>
                        </div>
                      )}

                      {!getIsSendingEnrolment() && (
                        <Row
                          marginTop="2em"
                          style={{
                            alignSelf: 'center',
                            flexDirection: 'column',
                          }}
                        >
                          <Button secondary onClick={onStoreStateOnServer}>
                            <Cell padding="0.1em 0em">
                              <Label bold size="1.2em">
                                Lagre utkast
                              </Label>
                            </Cell>
                          </Button>
                        </Row>
                      )}

                      {saveEnrolment.error === 'INVALID_INPUT' && (
                        <Label marginTop="1em" bold color={getBrandingColor(colorTypes.error)}>
                          Et eller flere av feltene inneholder ugyldig data.
                          Kontroller feltene og forsøk på nytt.
                        </Label>
                      )}
                      {saveEnrolment.error === 'SERVICES_DOWN' && (
                        <Label marginTop="1em" bold color={getBrandingColor(colorTypes.error)}>
                          En eller flere av tjenestene brukt til registrering
                          er nede. Vennligst prøv igjen senere.
                        </Label>
                      )}

                      {getIsSendingEnrolment() && (
                        <>
                          <LoadingIndicator style={{ top: '95px', transform: 'scale(0.8)' }} />
                          <Label style={{
                            fontSize: '1.2em',
                            position: 'relative',
                            top: '90px',
                            maxWidth: '70%',
                            whiteSpace: 'nowrap',
                          }}
                          >
                            {selectedAction === 'slaughter'
                              ? 'Kontrollerer for sykdommer og sender inn...'
                              : 'Sender inn...'}
                          </Label>
                        </>
                      )}
                      {!getIsSendingEnrolment() && (
                        <Row
                          marginTop="2em"
                          style={{
                            alignSelf: 'center',
                            flexDirection: 'column',
                          }}
                        >
                          <Button
                            primary
                            style={{ width: 'fit-content', alignSelf: 'center' }}
                            disabled={!getRegistrationReadyForSending() || getIsSendingEnrolment()}
                            onClick={onSubmitEnrolment}
                          >
                            <Cell padding="0.1em 0em">
                              <Label bold size="1.2em">
                                Send innmelding
                              </Label>
                            </Cell>
                          </Button>
                          {saveEnrolment.isFetching && (
                            <Label style={{ fontSize: '1.2em' }}>
                              {selectedAction === 'slaughter'
                                ? 'Kontrollerer for sykdommer og sender inn...'
                                : 'Sender inn...'}
                            </Label>
                          )}
                        </Row>
                      )}
                    </AfterStepsItems>
                  </>
                )}

              </StepWrapper>
          )}
        </>
      )}
    </RegisterSlaughterPage>
  );
};

export default withRouter(RegisterSlaughter);
